// This file is auto-generated by @hey-api/openapi-ts
import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import { client } from '../client.gen.js';
import { completeImageUpload, createDocument, createImageUpload, deleteDocument, getDocument, getDocumentDownloadUrl, getHealth, getHealthReady, getInvestor, getInvestorConfig, getStartupConfig, processLinkedIn, processPitchDeck, processWebsite, v2AcceptInvite, v2AcceptTerms, v2AdminAddFeatureFlagInvestor, v2AdminAddFeatureFlagStartup, v2AdminAddInvestorCredits, v2AdminAddStartupCredits, v2AdminAgentClients, v2AdminAgentOverview, v2AdminAgentSessionCalls, v2AdminBackfillTeamMemberLinkedIn, v2AdminChangeUserEmail, v2AdminCreateBlogPost, v2AdminCreateHelpArticle, v2AdminCreateHelpCategory, v2AdminCreateOutreachCreditTransaction, v2AdminDecideInvestorCheck, v2AdminDecideInvestorUpdateProposal, v2AdminDeleteBlogPost, v2AdminDeleteEvaluation, v2AdminDeleteHelpArticle, v2AdminDeleteHelpCategory, v2AdminDeletePitchSession, v2AdminDeletePrescreen, v2AdminDeleteStartup, v2AdminDeleteUser, v2AdminEjectOutreachSeat, v2AdminForceDisconnectStartupOutreach, v2AdminGetAutomatedEmailById, v2AdminGetBlogPost, v2AdminGetDashboard, v2AdminGetDataRoomAnalytics, v2AdminGetDataRoomById, v2AdminGetEmailTemplate, v2AdminGetEvaluationDetails, v2AdminGetEvaluationView, v2AdminGetHelpArticle, v2AdminGetInvestorById, v2AdminGetInvestorIndexStatus, v2AdminGetInvestorMemberships, v2AdminGetInvestorPersona, v2AdminGetInvestorPortfolioCompanies, v2AdminGetInvestorThesis, v2AdminGetJudgeProfile, v2AdminGetOutreachBillingDetail, v2AdminGetOutreachCopyArms, v2AdminGetOutreachMessageConversation, v2AdminGetOutreachReplyStats, v2AdminGetProfileChatById, v2AdminGetProfileChatTurnContext, v2AdminGetSignupQuestion, v2AdminGetStartupBilling, v2AdminGetStartupById, v2AdminGetStartupDeletionPreview, v2AdminGetStartupDocuments, v2AdminGetStartupEmailUpdates, v2AdminGetStartupMatchesRefreshStatus, v2AdminGetStartupMemberships, v2AdminGetStartupOutreachContacts, v2AdminGetStartupOutreachHeyReachDebug, v2AdminGetStartupOutreachOverview, v2AdminGetStartupOutreachStatus, v2AdminGetStartupOutreachVariants, v2AdminGetStartupPortfolioOutreachQueue, v2AdminGetStartupPortfolioOutreachStatus, v2AdminGetStartupTeamMembers, v2AdminGetUserById, v2AdminGetUserDeletionPreview, v2AdminGetUserMemberships, v2AdminGetWarmIntroCandidates, v2AdminGrantStartupEntitlement, v2AdminGrantStartupUsage, v2AdminListActivityResearch, v2AdminListAiInsightReports, v2AdminListAutomatedEmails, v2AdminListBlogPosts, v2AdminListDataRooms, v2AdminListEmailTemplates, v2AdminListEvaluations, v2AdminListFeatureFlags, v2AdminListFeedback, v2AdminListHelpCategories, v2AdminListInvestorChecks, v2AdminListInvestorCredits, v2AdminListInvestorDealFlowInteractions, v2AdminListInvestorDealFlowMatches, v2AdminListInvestors, v2AdminListInvestorUpdateProposals, v2AdminListManualCallBookingCandidates, v2AdminListMatcherJobs, v2AdminListObserverAlerts, v2AdminListObservers, v2AdminListOutreachBilling, v2AdminListOutreachCallCandidates, v2AdminListOutreachLimitsPending, v2AdminListOutreachReplyClassification, v2AdminListOutreachSeatQueue, v2AdminListOutreachStartupMetrics, v2AdminListOutreachWithdrawalRequests, v2AdminListPendingOutreach, v2AdminListPersonaResearch, v2AdminListPortfolioResearch, v2AdminListProfileChats, v2AdminListStartupCredits, v2AdminListStartupDealFlowInteractions, v2AdminListStartupEntitlements, v2AdminListStartupFacts, v2AdminListStartupFactSources, v2AdminListStartupMatches, v2AdminListStartupReactions, v2AdminListStartups, v2AdminListStartupTextFeedbacks, v2AdminListStuckAwaitingSenderOutreach, v2AdminListUnknownInvestorPreferences, v2AdminListUsers, v2AdminListUserTermsAcceptances, v2AdminMarkOutreachLimitsSet, v2AdminNormalizeInvestorPreferences, v2AdminOutreachCallDecision, v2AdminPauseInvestorContact, v2AdminPromoteOutreachSeat, v2AdminPublishInvestorIndex, v2AdminRecheckOutreach, v2AdminRecheckOutreachWorkspaceRemoved, v2AdminRedactProfileChatTurn, v2AdminRefreshInvestorDealFlowMatches, v2AdminRefreshStartupMatches, v2AdminRegenerateAiInsightReport, v2AdminRegenerateContactMessage, v2AdminRegenerateEvaluation, v2AdminRegeneratePortfolioMessages, v2AdminRegenerateStartupMessages, v2AdminRemoveFeatureFlagInvestor, v2AdminRemoveFeatureFlagStartup, v2AdminReorderHelpArticles, v2AdminReorderHelpCategories, v2AdminRerunOutreachReplyClassification, v2AdminRerunPortfolioOutreachReplyClassification, v2AdminRerunPrescreen, v2AdminRescanStartupFactSource, v2AdminResetStartupGrants, v2AdminResetStuckOutreachWorkspace, v2AdminResolveOutreachWithdrawalRequest, v2AdminRevokeStartupEntitlement, v2AdminSendAutomatedEmail, v2AdminSendInvestorDealFlowDigest, v2AdminSendTestEmailTemplate, v2AdminSetFeatureFlagEnabled, v2AdminSetMcpTextSet, v2AdminSetStartupInternal, v2AdminSetStartupProfileChatLimit, v2AdminTriggerActivityResearch, v2AdminTriggerPersonaResearch, v2AdminTriggerPortfolioResearch, v2AdminTriggerPrescreen, v2AdminUpdateBlogPost, v2AdminUpdateEmailTemplate, v2AdminUpdateHelpArticle, v2AdminUpdateHelpCategory, v2AdminUpdateInvestor, v2AdminUpdateSignupQuestion, v2ApproveAllStartupOutreachQueued, v2ApprovePortfolioContacts, v2ApproveStartupOutreachQueued, v2ArchivePortfolioMessage, v2ArchiveStartupOutreachContact, v2AutoUnlockTopMatch, v2CancelInvestorInvite, v2CancelStartupInvite, v2ConnectDealFlowMatch, v2ContactFounder, v2CreateAnalyticsExclusion, v2CreateConsentLog, v2CreateFeedback, v2CreateInvestor, v2CreateInvestorInvite, v2CreatePitch, v2CreateShareLink, v2CreateStartup, v2CreateStartupInvite, v2CreateTeamMember, v2CreateWalletTopUpCheckout, v2DeclineStartupOutreachQueued, v2DeleteAnalyticsExclusion, v2DeleteShareLink, v2DeleteTeamMember, v2DisableStartupOutreach, v2DownloadDealFlowMatchDocument, v2EnablePortfolioOutreach, v2EnableStartupOutreach, v2EvaluateStartup, v2FinishPitch, v2FounderInvitesClaim, v2FounderInvitesPreview, v2GenerateAnalyticsInsights, v2GenerateInvestorContactMessage, v2GetActiveEntitlements, v2GetAnalyticsSettings, v2GetBillingStatus, v2GetDealFlowMatch, v2GetDealFlowMatchVideoUrl, v2GetDealFlowSubscriptionStatus, v2GetFinFounderContext, v2GetInsightsReport, v2GetIntercomToken, v2GetInvestorCreditBalance, v2GetInvestorEvaluation, v2GetInvestorFeed, v2GetInvestorIndexPage, v2GetInvestorJudgeProfile, v2GetInvestorPersona, v2GetInvestorProfile, v2GetJudgeProfile, v2GetMe, v2GetMyMemberships, v2GetOutreachPricing, v2GetPitch, v2GetPitchEvaluation, v2GetPitchVideoUrl, v2GetPortfolioArchive, v2GetPortfolioContactPreviews, v2GetPortfolioOutreachMessages, v2GetPortfolioOutreachStatus, v2GetPortfolioQueue, v2GetPrescreenAllowance, v2GetPublicInvestorBySlug, v2GetPublicProfileFull, v2GetPublicProfilePreview, v2GetPublishedBlogPost, v2GetPublishedHelpArticle, v2GetSignInProviders, v2GetSignupQuestion, v2GetStartupAnalytics, v2GetStartupCreditBalance, v2GetStartupFeatureFlags, v2GetStartupFeed, v2GetStartupHomeState, v2GetStartupOutreachActivity, v2GetStartupOutreachArchive, v2GetStartupOutreachBody, v2GetStartupOutreachContactDecisions, v2GetStartupOutreachMessages, v2GetStartupOutreachOutcomes, v2GetStartupOutreachOverview, v2GetStartupOutreachQueue, v2GetStartupOutreachStatus, v2GetStartupOverview, v2GetStartupPitch, v2GetStartupProfile, v2GetStartupWallet, v2GetStatementReactions, v2GetWebsiteStats, v2InvestorAddWatchdogCriterion, v2InvestorBrowseStartups, v2InvestorConnectWithStartup, v2InvestorCreateFounderInvite, v2InvestorDeleteMcpData, v2InvestorDeleteNote, v2InvestorDisconnectMcpConnection, v2InvestorDismissFocusOffer, v2InvestorEditFollow, v2InvestorExportMcpData, v2InvestorFocusFromSearch, v2InvestorFollowStartup, v2InvestorGetFocus, v2InvestorGetMcpSettings, v2InvestorGetStartupRelationship, v2InvestorGetWatchdog, v2InvestorListFollows, v2InvestorListFounderInvites, v2InvestorListMcpConnections, v2InvestorListNotes, v2InvestorListNotifications, v2InvestorMarkNotificationsRead, v2InvestorMarkWatchdogStartupSeen, v2InvestorNotifyWhenInChatgpt, v2InvestorPass, v2InvestorRecentSearches, v2InvestorRemoveFounderInvite, v2InvestorRemoveWatchdogCriterion, v2InvestorReopenPass, v2InvestorRestoreSearch, v2InvestorSaveFocus, v2InvestorSavePrivateNote, v2InvestorSearch, v2InvestorSearchSuggestions, v2InvestorSetWatchdogCriterionLocked, v2InvestorSetWatchdogPaused, v2InvestorShareStartup, v2InvestorUnfollowStartup, v2InvestorUpdateMcpSettings, v2JoinAgentWaitlist, v2LaunchPortfolioCampaign, v2LaunchStartupOutreach, v2LinkStartupDocument, v2ListAccess, v2ListDealFlowArchive, v2ListDealFlowMatches, v2ListInvestorCredits, v2ListInvestorEvaluationRequests, v2ListInvestorIndexPages, v2ListInvestorInvites, v2ListPublishedBlogPosts, v2ListPublishedHelpCategories, v2ListShareLinks, v2ListStartupCredits, v2ListStartupDocuments, v2ListStartupDocumentVersions, v2ListStartupInvites, v2ListStartupMatches, v2ListTeamMembers, v2LookupInvite, v2MarkPostImprovementPromptShown, v2MarkRepliesSeen, v2OpenWalletBillingPortal, v2PassDealFlowMatch, v2PausePortfolioOutreach, v2ProfileChat, v2ProfileChatContext, v2ProfileChatHistory, v2ProfileChatPreview, v2ProfileChatPreviewContext, v2ProfileHeartbeat, v2ProfileTrackEvent, v2ProfileTrackEventBatch, v2PublicDocumentDownload, v2PublicVideoUrl, v2RecordSignupAnswer, v2RecordSignupSource, v2RecordStartupContactInvestor, v2RefreshTeamMemberLinkedIn, v2RegisterProfileVisitor, v2RemoveAccess, v2RemoveStartupOutreachInProgressLead, v2ReorderTeamMembers, v2RequestInvestorEvaluation, v2RequestOutreachDisconnect, v2RequestStartupMatchEvaluation, v2RequestWalletWithdrawal, v2ResetPortfolioOutreachMessage, v2ResetStartupOutreachMessage, v2RestorePortfolioArchived, v2RestoreStartupOutreachArchived, v2ResumePortfolioOutreach, v2ReviewPortfolioOutreachMessages, v2ReviewStartupOutreachMessages, v2SearchPublishedHelpArticles, v2SelectStartupOutreachChannels, v2SetDistributionIntent, v2SetPortfolioContactDecisions, v2SetStartupOutreachContactDecisions, v2SetStartupStealthChoice, v2SkipAllPortfolioQueued, v2SkipAllStartupOutreachQueued, v2SnoozeShareStep, v2StartPitch, v2StartupGetAiReads, v2StartupGetEmailUpdates, v2StartupListFollowers, v2StartupRemoveEmailUpdate, v2StartupRemoveFollower, v2StripeWebhook, v2SubmitInterestDecision, v2SubmitPortfolioWarmIntroDecision, v2SubmitStatementReaction, v2SubmitTextFeedback, v2SubscribeToDealFlow, v2TriggerPrescreen, v2UnlinkStartupDocument, v2UnsubscribeConfirm, v2UnsubscribeFromDealFlow, v2UnsubscribePage, v2UpdateInvestorMember, v2UpdateInvestorProfile, v2UpdateMe, v2UpdatePitch, v2UpdatePortfolioOutreachMessages, v2UpdateShareLink, v2UpdateStartupDocument, v2UpdateStartupOutreachBody, v2UpdateStartupOutreachMessages, v2UpdateStartupProfile, v2UpdateTeamMember, v2WebhookHeyreachCampaignCompleted, v2WebhookHeyreachConnectionAccepted, v2WebhookHeyreachConnectionRequestSent, v2WebhookHeyreachEveryMessageReply, v2WebhookHeyreachLikedPost, v2WebhookHeyreachMessageReply, v2WebhookHeyreachViewedProfile, v2WebhookResendInbound, verifyDocument } from '../sdk.gen.js';
const createQueryKey = (id, options, infinite, tags) => {
    const params = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl };
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};
export const getHealthQueryKey = (options) => createQueryKey('getHealth', options);
/**
 * Check if the service is alive and responding
 */
export const getHealthOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHealthQueryKey(options)
});
export const getHealthReadyQueryKey = (options) => createQueryKey('getHealthReady', options);
/**
 * Check if the service is ready to accept traffic
 */
export const getHealthReadyOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHealthReady({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHealthReadyQueryKey(options)
});
/**
 * Create document and get presigned upload URL
 */
export const createDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a document
 *
 * Deletes document from storage and database
 */
export const deleteDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getDocumentQueryKey = (options) => createQueryKey('getDocument', options);
/**
 * Get document detail by id
 */
export const getDocumentOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDocumentQueryKey(options)
});
/**
 * Verify uploaded document
 */
export const verifyDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Generate short-lived download URL
 */
export const getDocumentDownloadUrlMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await getDocumentDownloadUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Create presigned URL for image upload
 *
 * @deprecated
 */
export const createImageUploadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await createImageUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Validate uploaded image and get public URL
 *
 * @deprecated
 */
export const completeImageUploadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeImageUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const getStartupConfigQueryKey = (options) => createQueryKey('getStartupConfig', options);
/**
 * Get startup configuration data
 *
 * Returns categories, product stages, raise stages, and status options for dropdowns
 *
 * @deprecated
 */
export const getStartupConfigOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStartupConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStartupConfigQueryKey(options)
});
export const getInvestorConfigQueryKey = (options) => createQueryKey('getInvestorConfig', options);
/**
 * Get investor configuration data
 *
 * Returns investment areas and regions for investor profile dropdowns
 *
 * @deprecated
 */
export const getInvestorConfigOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvestorConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvestorConfigQueryKey(options)
});
export const getInvestorQueryKey = (options) => createQueryKey('getInvestor', options);
/**
 * Get user's investor
 *
 * Get the investor associated with the current investor user
 *
 * @deprecated
 */
export const getInvestorOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInvestor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInvestorQueryKey(options)
});
/**
 * Scrape LinkedIn profile data via Apify
 */
export const processLinkedInMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await processLinkedIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Extract startup data from a pitch deck PDF
 */
export const processPitchDeckMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await processPitchDeck({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Extract data from a website using AI
 */
export const processWebsiteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await processWebsite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Create a new startup
 */
export const v2CreateStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupOverviewQueryKey = (options) => createQueryKey('v2GetStartupOverview', options);
/**
 * Get startup overview dashboard
 */
export const v2GetStartupOverviewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupOverview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupOverviewQueryKey(options)
});
export const v2GetStartupHomeStateQueryKey = (options) => createQueryKey('v2GetStartupHomeState', options);
/**
 * Resolve the Home wizard focus state for a startup
 */
export const v2GetStartupHomeStateOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupHomeState({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupHomeStateQueryKey(options)
});
export const v2GetStartupProfileQueryKey = (options) => createQueryKey('v2GetStartupProfile', options);
/**
 * Get startup profile for data room
 */
export const v2GetStartupProfileOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupProfileQueryKey(options)
});
/**
 * Update startup profile
 */
export const v2UpdateStartupProfileMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateStartupProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupPitchQueryKey = (options) => createQueryKey('v2GetStartupPitch', options);
/**
 * Get pitch overview for startup
 */
export const v2GetStartupPitchOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupPitch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupPitchQueryKey(options)
});
export const v2GetStartupCreditBalanceQueryKey = (options) => createQueryKey('v2GetStartupCreditBalance', options);
/**
 * Get startup credit balance
 */
export const v2GetStartupCreditBalanceOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupCreditBalance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupCreditBalanceQueryKey(options)
});
export const v2ListStartupCreditsQueryKey = (options) => createQueryKey('v2ListStartupCredits', options);
/**
 * List startup credit transactions
 */
export const v2ListStartupCreditsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListStartupCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListStartupCreditsQueryKey(options)
});
export const v2GetAnalyticsSettingsQueryKey = (options) => createQueryKey('v2GetAnalyticsSettings', options);
/**
 * Get analytics settings (exclusions)
 */
export const v2GetAnalyticsSettingsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetAnalyticsSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetAnalyticsSettingsQueryKey(options)
});
/**
 * Add an email or domain to the analytics exclusion list
 */
export const v2CreateAnalyticsExclusionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateAnalyticsExclusion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Remove an analytics exclusion entry
 */
export const v2DeleteAnalyticsExclusionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2DeleteAnalyticsExclusion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupFeedQueryKey = (options) => createQueryKey('v2GetStartupFeed', options);
/**
 * Get startup activity feed
 */
export const v2GetStartupFeedOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupFeed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupFeedQueryKey(options)
});
export const v2GetPitchEvaluationQueryKey = (options) => createQueryKey('v2GetPitchEvaluation', options);
/**
 * Get full pitch evaluation detail
 */
export const v2GetPitchEvaluationOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPitchEvaluation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPitchEvaluationQueryKey(options)
});
export const v2GetJudgeProfileQueryKey = (options) => createQueryKey('v2GetJudgeProfile', options);
/**
 * Get judge profile for a specific evaluation
 */
export const v2GetJudgeProfileOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetJudgeProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetJudgeProfileQueryKey(options)
});
export const v2GetPrescreenAllowanceQueryKey = (options) => createQueryKey('v2GetPrescreenAllowance', options);
/**
 * Get remaining feedback runs for the rolling week
 */
export const v2GetPrescreenAllowanceOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPrescreenAllowance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPrescreenAllowanceQueryKey(options)
});
/**
 * Trigger prescreen for a pitch deck document
 */
export const v2TriggerPrescreenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2TriggerPrescreen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListTeamMembersQueryKey = (options) => createQueryKey('v2ListTeamMembers', options);
/**
 * List team members
 */
export const v2ListTeamMembersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListTeamMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListTeamMembersQueryKey(options)
});
/**
 * Create a team member
 */
export const v2CreateTeamMemberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Reorder team members
 */
export const v2ReorderTeamMembersMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ReorderTeamMembers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a team member
 */
export const v2DeleteTeamMemberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2DeleteTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Update a team member
 */
export const v2UpdateTeamMemberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Force re-scrape of a team member's LinkedIn profile
 */
export const v2RefreshTeamMemberLinkedInMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RefreshTeamMemberLinkedIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Remove a startup member (owner only, cannot remove owners)
 */
export const v2RemoveAccessMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RemoveAccess({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListStartupDocumentsQueryKey = (options) => createQueryKey('v2ListStartupDocuments', options);
/**
 * List documents linked to a startup
 */
export const v2ListStartupDocumentsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListStartupDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListStartupDocumentsQueryKey(options)
});
/**
 * Link a document to a startup
 */
export const v2LinkStartupDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2LinkStartupDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListStartupDocumentVersionsQueryKey = (options) => createQueryKey('v2ListStartupDocumentVersions', options);
/**
 * List every version of the startup documents, newest first, with dates
 */
export const v2ListStartupDocumentVersionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListStartupDocumentVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListStartupDocumentVersionsQueryKey(options)
});
/**
 * Unlink a document from a startup
 */
export const v2UnlinkStartupDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UnlinkStartupDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Update startup document label
 */
export const v2UpdateStartupDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateStartupDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListAccessQueryKey = (options) => createQueryKey('v2ListAccess', options);
/**
 * List startup memberships (users with access)
 */
export const v2ListAccessOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListAccess({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListAccessQueryKey(options)
});
export const v2ListStartupMatchesQueryKey = (options) => createQueryKey('v2ListStartupMatches', options);
/**
 * List recommended investors for a startup
 */
export const v2ListStartupMatchesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListStartupMatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListStartupMatchesQueryKey(options)
});
const createInfiniteParams = (queryKey, page) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body,
            ...page.body
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path,
            ...page.path
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query,
            ...page.query
        };
    }
    return params;
};
export const v2ListStartupMatchesInfiniteQueryKey = (options) => createQueryKey('v2ListStartupMatches', options, true);
/**
 * List recommended investors for a startup
 */
export const v2ListStartupMatchesInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2ListStartupMatches({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListStartupMatchesInfiniteQueryKey(options)
});
/**
 * Request a custom-persona evaluation against the latest pitch
 *
 * Resolves the most recent COMPLETED pitch session for the startup and creates an investor evaluation request against it. Idempotent.
 */
export const v2RequestStartupMatchEvaluationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RequestStartupMatchEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Auto-unlock the top-rerank match for the startup (free, idempotent).
 *
 * On first call after the matcher has produced results, runs the same flow as "See their take" against the highest-rerank investor without consuming an evaluation credit. Subsequent calls no-op.
 */
export const v2AutoUnlockTopMatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AutoUnlockTopMatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Record that the founder clicked through to an investor website
 *
 * Fire-and-forget: logs a Recombee CartAddition signal. Does not send any outbound communication.
 */
export const v2RecordStartupContactInvestorMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RecordStartupContactInvestor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Generate a personalized LinkedIn contact message for an investor GP
 */
export const v2GenerateInvestorContactMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2GenerateInvestorContactMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupOutreachBodyQueryKey = (options) => createQueryKey('v2GetStartupOutreachBody', options);
/**
 * Get saved outreach body message for a startup
 */
export const v2GetStartupOutreachBodyOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupOutreachBody({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupOutreachBodyQueryKey(options)
});
/**
 * Save outreach body message for a startup
 */
export const v2UpdateStartupOutreachBodyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateStartupOutreachBody({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Record the founder explicit stealth/visible choice for a startup
 */
export const v2SetStartupStealthChoiceMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SetStartupStealthChoice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Set which path the founder is on for reaching investors (self-share or outreach)
 */
export const v2SetDistributionIntentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SetDistributionIntent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Snooze the Home Share step for 7 days
 */
export const v2SnoozeShareStepMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SnoozeShareStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Stamp the once-per-day cap on the post-improvement prompt
 */
export const v2MarkPostImprovementPromptShownMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2MarkPostImprovementPromptShown({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2StartupListFollowersQueryKey = (options) => createQueryKey('v2StartupListFollowers', options);
/**
 * List the investors actively following this startup (name, title, firm only)
 */
export const v2StartupListFollowersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2StartupListFollowers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2StartupListFollowersQueryKey(options)
});
/**
 * Remove an investor from this startup’s followers
 */
export const v2StartupRemoveFollowerMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2StartupRemoveFollower({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2StartupGetEmailUpdatesQueryKey = (options) => createQueryKey('v2StartupGetEmailUpdates', options);
/**
 * The startup’s updates address (made on first look), the updates received by email and what was held
 */
export const v2StartupGetEmailUpdatesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2StartupGetEmailUpdates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2StartupGetEmailUpdatesQueryKey(options)
});
/**
 * Take an update received by email off the profile
 */
export const v2StartupRemoveEmailUpdateMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2StartupRemoveEmailUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2StartupGetAiReadsQueryKey = (options) => createQueryKey('v2StartupGetAiReads', options);
/**
 * Anonymous lines about how investors’ AI assistants used this record
 */
export const v2StartupGetAiReadsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2StartupGetAiReads({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2StartupGetAiReadsQueryKey(options)
});
/**
 * Create a new investor entity
 */
export const v2CreateInvestorMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateInvestor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetInvestorProfileQueryKey = (options) => createQueryKey('v2GetInvestorProfile', options);
/**
 * Get investor profile
 */
export const v2GetInvestorProfileOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorProfileQueryKey(options)
});
/**
 * Update investor profile
 */
export const v2UpdateInvestorProfileMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateInvestorProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Set the signed-in person’s own title at this investor
 */
export const v2UpdateInvestorMemberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateInvestorMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetInvestorPersonaQueryKey = (options) => createQueryKey('v2GetInvestorPersona', options);
/**
 * Get investor persona status and brief
 */
export const v2GetInvestorPersonaOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorPersona({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorPersonaQueryKey(options)
});
export const v2GetInvestorCreditBalanceQueryKey = (options) => createQueryKey('v2GetInvestorCreditBalance', options);
/**
 * Get investor credit balance
 */
export const v2GetInvestorCreditBalanceOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorCreditBalance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorCreditBalanceQueryKey(options)
});
export const v2ListInvestorCreditsQueryKey = (options) => createQueryKey('v2ListInvestorCredits', options);
/**
 * List investor credit transactions
 */
export const v2ListInvestorCreditsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListInvestorCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListInvestorCreditsQueryKey(options)
});
export const v2GetInvestorFeedQueryKey = (options) => createQueryKey('v2GetInvestorFeed', options);
/**
 * Get investor pitch feed
 */
export const v2GetInvestorFeedOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorFeed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorFeedQueryKey(options)
});
export const v2GetInvestorEvaluationQueryKey = (options) => createQueryKey('v2GetInvestorEvaluation', options);
/**
 * Get evaluation detail for investor
 */
export const v2GetInvestorEvaluationOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorEvaluation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorEvaluationQueryKey(options)
});
export const v2GetInvestorJudgeProfileQueryKey = (options) => createQueryKey('v2GetInvestorJudgeProfile', options);
/**
 * Get judge profile for investor evaluation
 */
export const v2GetInvestorJudgeProfileOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorJudgeProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorJudgeProfileQueryKey(options)
});
/**
 * Send connection request to startup from evaluation
 */
export const v2InvestorConnectWithStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorConnectWithStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListInvestorEvaluationRequestsQueryKey = (options) => createQueryKey('v2ListInvestorEvaluationRequests', options);
/**
 * List all evaluation requests for investor
 */
export const v2ListInvestorEvaluationRequestsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListInvestorEvaluationRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListInvestorEvaluationRequestsQueryKey(options)
});
/**
 * Request personalized evaluation
 *
 * Request a personalized evaluation using the investor custom persona.
 */
export const v2RequestInvestorEvaluationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RequestInvestorEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Evaluate startup from investor perspective
 *
 * Triggers a custom evaluation for a startup. Uses the latest completed pitch session if available, otherwise falls back to prescreen using the pitch deck.
 */
export const v2EvaluateStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2EvaluateStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2InvestorListFollowsQueryKey = (options) => createQueryKey('v2InvestorListFollows', options);
/**
 * List the caller's own follows, with their own conditions
 */
export const v2InvestorListFollowsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorListFollows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorListFollowsQueryKey(options)
});
/**
 * Follow a startup for every major update or for a condition the investor names
 */
export const v2InvestorFollowStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorFollowStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Stop following a startup
 */
export const v2InvestorUnfollowStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorUnfollowStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Change what a follow waits for, keeping everything else the follow holds
 */
export const v2InvestorEditFollowMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorEditFollow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2InvestorBrowseStartupsQueryKey = (options) => createQueryKey('v2InvestorBrowseStartups', options);
/**
 * Startups open to discovery, newest first, each marked with what it is to the investor
 */
export const v2InvestorBrowseStartupsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorBrowseStartups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorBrowseStartupsQueryKey(options)
});
export const v2InvestorBrowseStartupsInfiniteQueryKey = (options) => createQueryKey('v2InvestorBrowseStartups', options, true);
/**
 * Startups open to discovery, newest first, each marked with what it is to the investor
 */
export const v2InvestorBrowseStartupsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2InvestorBrowseStartups({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorBrowseStartupsInfiniteQueryKey(options)
});
export const v2InvestorListFounderInvitesQueryKey = (options) => createQueryKey('v2InvestorListFounderInvites', options);
/**
 * The founder invites the investor has made, newest first
 */
export const v2InvestorListFounderInvitesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorListFounderInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorListFounderInvitesQueryKey(options)
});
/**
 * Ask a founder to join SeedForge; returns the invite link and a drafted message
 */
export const v2InvestorCreateFounderInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorCreateFounderInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Remove an invite still waiting for its founder; its link stops working
 */
export const v2InvestorRemoveFounderInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorRemoveFounderInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2FounderInvitesPreviewQueryKey = (options) => createQueryKey('v2FounderInvitesPreview', options);
/**
 * What a founder sees on an invite link; one neutral 404 for an unknown, used or removed link
 */
export const v2FounderInvitesPreviewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2FounderInvitesPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2FounderInvitesPreviewQueryKey(options)
});
/**
 * A founder joins through an invite with one of their startups
 */
export const v2FounderInvitesClaimMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2FounderInvitesClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2InvestorGetWatchdogQueryKey = (options) => createQueryKey('v2InvestorGetWatchdog', options);
/**
 * The watchdog: what it looks for, and the startups it has found for the investor
 */
export const v2InvestorGetWatchdogOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorGetWatchdog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorGetWatchdogQueryKey(options)
});
export const v2InvestorGetFocusQueryKey = (options) => createQueryKey('v2InvestorGetFocus', options);
/**
 * The investor's own focus (Settings), the same focus the watchdog shows
 */
export const v2InvestorGetFocusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorGetFocus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorGetFocusQueryKey(options)
});
/**
 * Save the investor's own focus; the watchdog's focus is the same list
 */
export const v2InvestorSaveFocusMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorSaveFocus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Pause or resume the watchdog; a paused watchdog keeps what it has shown
 */
export const v2InvestorSetWatchdogPausedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorSetWatchdogPaused({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Mark a startup's watchdog match as seen, once the investor visits its data room
 */
export const v2InvestorMarkWatchdogStartupSeenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorMarkWatchdogStartupSeen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Add something the watchdog should look for
 */
export const v2InvestorAddWatchdogCriterionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorAddWatchdogCriterion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Remove a criterion; the focus it came from stays as it is
 */
export const v2InvestorRemoveWatchdogCriterionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorRemoveWatchdogCriterion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Lock or unlock a criterion; a locked criterion stays until it is removed
 */
export const v2InvestorSetWatchdogCriterionLockedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorSetWatchdogCriterionLocked({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Search the startups open to the app by a phrase; quotes come only from a passed account check
 */
export const v2InvestorSearchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorSearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2InvestorRecentSearchesQueryKey = (options) => createQueryKey('v2InvestorRecentSearches', options);
/**
 * The investor’s most recent searches, newest first
 */
export const v2InvestorRecentSearchesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorRecentSearches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorRecentSearchesQueryKey(options)
});
export const v2InvestorRestoreSearchQueryKey = (options) => createQueryKey('v2InvestorRestoreSearch', options);
/**
 * Run a saved search again with the criteria it was saved with (nothing is counted)
 */
export const v2InvestorRestoreSearchOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorRestoreSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorRestoreSearchQueryKey(options)
});
export const v2InvestorSearchSuggestionsQueryKey = (options) => createQueryKey('v2InvestorSearchSuggestions', options);
/**
 * Starting points from the investor’s focus, with how many startups each one shows now
 */
export const v2InvestorSearchSuggestionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorSearchSuggestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorSearchSuggestionsQueryKey(options)
});
/**
 * Use the criteria of a search as the investor’s locked watchdog focus
 */
export const v2InvestorFocusFromSearchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorFocusFromSearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Not now: the focus offer is not asked again
 */
export const v2InvestorDismissFocusOfferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorDismissFocusOffer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Reopen a startup the caller passed on: the pass is removed, nothing else changes
 */
export const v2InvestorReopenPassMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorReopenPass({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Pass on a startup, with a reason and an optional “would look again when”. Never a follow.
 */
export const v2InvestorPassMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorPass({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * A drafted message about a startup and the link the investor holds, to send to another investor
 */
export const v2InvestorShareStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorShareStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2InvestorGetStartupRelationshipQueryKey = (options) => createQueryKey('v2InvestorGetStartupRelationship', options);
/**
 * What one startup is to the investor: the follow and its state, updates since, the saved read and the pass
 */
export const v2InvestorGetStartupRelationshipOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorGetStartupRelationship({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorGetStartupRelationshipQueryKey(options)
});
/**
 * Save the investor's own note on a startup; empty text removes it
 */
export const v2InvestorSavePrivateNoteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorSavePrivateNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete the caller's kept note on a startup, every version of it
 */
export const v2InvestorDeleteNoteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorDeleteNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2InvestorGetMcpSettingsQueryKey = (options) => createQueryKey('v2InvestorGetMcpSettings', options);
/**
 * The investor’s privacy switches for their AI assistant and alert emails
 */
export const v2InvestorGetMcpSettingsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorGetMcpSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorGetMcpSettingsQueryKey(options)
});
/**
 * Change the investor’s privacy switches (only what is sent changes)
 */
export const v2InvestorUpdateMcpSettingsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorUpdateMcpSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2InvestorListNotificationsQueryKey = (options) => createQueryKey('v2InvestorListNotifications', options);
/**
 * The investor’s alert inbox, newest first, with the unread count
 */
export const v2InvestorListNotificationsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorListNotifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorListNotificationsQueryKey(options)
});
/**
 * Mark notifications read (all, or the ids given)
 */
export const v2InvestorMarkNotificationsReadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorMarkNotificationsRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2InvestorListNotesQueryKey = (options) => createQueryKey('v2InvestorListNotes', options);
/**
 * The investor’s kept notes and passes
 */
export const v2InvestorListNotesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorListNotes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorListNotesQueryKey(options)
});
export const v2InvestorExportMcpDataQueryKey = (options) => createQueryKey('v2InvestorExportMcpData', options);
/**
 * Everything the investor owns in the AI assistant features, as one document
 */
export const v2InvestorExportMcpDataOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorExportMcpData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorExportMcpDataQueryKey(options)
});
/**
 * Delete everything the investor owns in the AI assistant features (the account stays)
 */
export const v2InvestorDeleteMcpDataMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorDeleteMcpData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2InvestorListMcpConnectionsQueryKey = (options) => createQueryKey('v2InvestorListMcpConnections', options);
/**
 * The AI assistants the investor has signed in, with when each was last used
 */
export const v2InvestorListMcpConnectionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2InvestorListMcpConnections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2InvestorListMcpConnectionsQueryKey(options)
});
/**
 * Disconnect one AI assistant: its sign-in and tokens end
 */
export const v2InvestorDisconnectMcpConnectionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorDisconnectMcpConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Ask to be told when SeedForge is in ChatGPT’s app directory
 */
export const v2InvestorNotifyWhenInChatgptMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2InvestorNotifyWhenInChatgpt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetMeQueryKey = (options) => createQueryKey('v2GetMe', options);
/**
 * Get current user's profile data
 */
export const v2GetMeOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetMeQueryKey(options)
});
/**
 * Update current user's profile data
 *
 * Update user information including name, bio, location, and social links
 */
export const v2UpdateMeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateMe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetMyMembershipsQueryKey = (options) => createQueryKey('v2GetMyMemberships', options);
/**
 * Get all memberships (startups and investors) the current user belongs to
 */
export const v2GetMyMembershipsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetMyMemberships({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetMyMembershipsQueryKey(options)
});
export const v2GetIntercomTokenQueryKey = (options) => createQueryKey('v2GetIntercomToken', options);
/**
 * Get the Intercom Messenger identity verification JWT for the current user
 */
export const v2GetIntercomTokenOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetIntercomToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetIntercomTokenQueryKey(options)
});
/**
 * Record acceptance of the current terms and privacy versions
 */
export const v2AcceptTermsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AcceptTerms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListStartupInvitesQueryKey = (options) => createQueryKey('v2ListStartupInvites', options);
/**
 * List pending invites for a startup
 */
export const v2ListStartupInvitesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListStartupInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListStartupInvitesQueryKey(options)
});
/**
 * Invite a user to a startup
 */
export const v2CreateStartupInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateStartupInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Cancel a pending invite
 */
export const v2CancelStartupInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CancelStartupInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListInvestorInvitesQueryKey = (options) => createQueryKey('v2ListInvestorInvites', options);
/**
 * List pending invites for an investor
 */
export const v2ListInvestorInvitesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListInvestorInvites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListInvestorInvitesQueryKey(options)
});
/**
 * Invite a user to an investor organization
 */
export const v2CreateInvestorInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateInvestorInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Cancel a pending investor invite
 */
export const v2CancelInvestorInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CancelInvestorInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2LookupInviteQueryKey = (options) => createQueryKey('v2LookupInvite', options);
/**
 * Look up invite details by token
 */
export const v2LookupInviteOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2LookupInvite({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2LookupInviteQueryKey(options)
});
/**
 * Accept a team invite
 */
export const v2AcceptInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AcceptInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Create pitch session
 */
export const v2CreatePitchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreatePitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetPitchQueryKey = (options) => createQueryKey('v2GetPitch', options);
/**
 * Get pitch session
 */
export const v2GetPitchOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPitch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPitchQueryKey(options)
});
/**
 * Update pitch session
 */
export const v2UpdatePitchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdatePitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Start pitch session
 */
export const v2StartPitchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2StartPitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Finish pitch session
 */
export const v2FinishPitchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2FinishPitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get pitch video URL
 */
export const v2GetPitchVideoUrlMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2GetPitchVideoUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListShareLinksQueryKey = (options) => createQueryKey('v2ListShareLinks', options);
/**
 * List share links for a startup
 */
export const v2ListShareLinksOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListShareLinks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListShareLinksQueryKey(options)
});
/**
 * Create a new share link
 */
export const v2CreateShareLinkMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateShareLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a share link
 */
export const v2DeleteShareLinkMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2DeleteShareLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Update a share link
 */
export const v2UpdateShareLinkMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateShareLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetPublicProfilePreviewQueryKey = (options) => createQueryKey('v2GetPublicProfilePreview', options);
/**
 * Get public profile preview by share link token
 */
export const v2GetPublicProfilePreviewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPublicProfilePreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPublicProfilePreviewQueryKey(options)
});
/**
 * Record an investor door submission (agent brief or thesis fit)
 */
export const v2JoinAgentWaitlistMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2JoinAgentWaitlist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Register as a profile visitor with email
 */
export const v2RegisterProfileVisitorMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RegisterProfileVisitor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetPublicProfileFullQueryKey = (options) => createQueryKey('v2GetPublicProfileFull', options);
/**
 * Get full public startup profile by share link token
 */
export const v2GetPublicProfileFullOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPublicProfileFull({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPublicProfileFullQueryKey(options)
});
/**
 * Send a heartbeat for profile viewing analytics
 */
export const v2ProfileHeartbeatMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ProfileHeartbeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Track a profile interaction event (click, document open/close)
 */
export const v2ProfileTrackEventMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ProfileTrackEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Track multiple profile events in a single request (for page unload)
 */
export const v2ProfileTrackEventBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ProfileTrackEventBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Ask a question about the profile (Server-Sent Events)
 */
export const v2ProfileChatMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ProfileChat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Ask a question about your own profile (Server-Sent Events)
 */
export const v2ProfileChatPreviewMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ProfileChatPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get the sources the chat would read on your own profile
 */
export const v2ProfileChatPreviewContextMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ProfileChatPreviewContext({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get the sources and remaining questions for the profile chat
 */
export const v2ProfileChatContextMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ProfileChatContext({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get the prior turns of one chat session, for a page reload
 */
export const v2ProfileChatHistoryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ProfileChatHistory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get a presigned download URL for a public profile document
 */
export const v2PublicDocumentDownloadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2PublicDocumentDownload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Get a presigned URL for the pitch recording video
 */
export const v2PublicVideoUrlMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2PublicVideoUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Send a connection request message to the startup founder
 */
export const v2ContactFounderMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ContactFounder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Submit or remove a thumbs up/down reaction on a statement
 */
export const v2SubmitStatementReactionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SubmitStatementReaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Record the visitor's interest-gate verdict on a share link
 */
export const v2SubmitInterestDecisionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SubmitInterestDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStatementReactionsQueryKey = (options) => createQueryKey('v2GetStatementReactions', options);
/**
 * Get all statement reactions for a visitor
 */
export const v2GetStatementReactionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStatementReactions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStatementReactionsQueryKey(options)
});
/**
 * Submit agree/disagree feedback on selected text
 */
export const v2SubmitTextFeedbackMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SubmitTextFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupAnalyticsQueryKey = (options) => createQueryKey('v2GetStartupAnalytics', options);
/**
 * Get anonymized founder analytics for a startup
 */
export const v2GetStartupAnalyticsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupAnalytics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupAnalyticsQueryKey(options)
});
export const v2GetInsightsReportQueryKey = (options) => createQueryKey('v2GetInsightsReport', options);
/**
 * Get the latest AI engagement report
 */
export const v2GetInsightsReportOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInsightsReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInsightsReportQueryKey(options)
});
/**
 * Generate AI-powered engagement report from investor behavior
 */
export const v2GenerateAnalyticsInsightsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2GenerateAnalyticsInsights({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetPublicInvestorBySlugQueryKey = (options) => createQueryKey('v2GetPublicInvestorBySlug', options);
/**
 * Get public investor profile by slug
 */
export const v2GetPublicInvestorBySlugOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPublicInvestorBySlug({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPublicInvestorBySlugQueryKey(options)
});
export const v2GetWebsiteStatsQueryKey = (options) => createQueryKey('v2GetWebsiteStats', options);
/**
 * Get website stats
 *
 * Returns aggregate counts used on the marketing landing page
 */
export const v2GetWebsiteStatsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetWebsiteStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetWebsiteStatsQueryKey(options)
});
export const v2UnsubscribePageQueryKey = (options) => createQueryKey('v2UnsubscribePage', options);
/**
 * Unsubscribe confirmation page (first click)
 */
export const v2UnsubscribePageOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2UnsubscribePage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2UnsubscribePageQueryKey(options)
});
/**
 * Confirm unsubscribe (second click — form submit from the page)
 */
export const v2UnsubscribeConfirmMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UnsubscribeConfirm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Record a website visitor's cookie choice (proof of consent)
 */
export const v2CreateConsentLogMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateConsentLog({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Submit user feedback (general or evaluation)
 */
export const v2CreateFeedbackMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetDashboardQueryKey = (options) => createQueryKey('v2AdminGetDashboard', options);
/**
 * Aggregate product metrics for the admin dashboard
 */
export const v2AdminGetDashboardOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetDashboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetDashboardQueryKey(options)
});
export const v2AdminListUsersQueryKey = (options) => createQueryKey('v2AdminListUsers', options);
/**
 * List all users (admin)
 */
export const v2AdminListUsersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListUsersQueryKey(options)
});
export const v2AdminListUsersInfiniteQueryKey = (options) => createQueryKey('v2AdminListUsers', options, true);
/**
 * List all users (admin)
 */
export const v2AdminListUsersInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListUsers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListUsersInfiniteQueryKey(options)
});
/**
 * Delete user and associated data (admin)
 */
export const v2AdminDeleteUserMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeleteUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetUserByIdQueryKey = (options) => createQueryKey('v2AdminGetUserById', options);
/**
 * Get user by ID (admin)
 */
export const v2AdminGetUserByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetUserById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetUserByIdQueryKey(options)
});
export const v2AdminListUserTermsAcceptancesQueryKey = (options) => createQueryKey('v2AdminListUserTermsAcceptances', options);
/**
 * List every acceptance of the terms and privacy versions for a user (admin)
 */
export const v2AdminListUserTermsAcceptancesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListUserTermsAcceptances({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListUserTermsAcceptancesQueryKey(options)
});
export const v2AdminGetUserMembershipsQueryKey = (options) => createQueryKey('v2AdminGetUserMemberships', options);
/**
 * Get user memberships (startups and investors)
 */
export const v2AdminGetUserMembershipsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetUserMemberships({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetUserMembershipsQueryKey(options)
});
export const v2AdminGetUserDeletionPreviewQueryKey = (options) => createQueryKey('v2AdminGetUserDeletionPreview', options);
/**
 * Get user deletion preview (admin)
 */
export const v2AdminGetUserDeletionPreviewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetUserDeletionPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetUserDeletionPreviewQueryKey(options)
});
export const v2AdminGetStartupDeletionPreviewQueryKey = (options) => createQueryKey('v2AdminGetStartupDeletionPreview', options);
/**
 * Get startup deletion preview (admin)
 */
export const v2AdminGetStartupDeletionPreviewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupDeletionPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupDeletionPreviewQueryKey(options)
});
/**
 * Delete startup and associated data (admin)
 */
export const v2AdminDeleteStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeleteStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetStartupByIdQueryKey = (options) => createQueryKey('v2AdminGetStartupById', options);
/**
 * Get startup by ID (admin)
 */
export const v2AdminGetStartupByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupByIdQueryKey(options)
});
/**
 * Change a user login email (admin)
 */
export const v2AdminChangeUserEmailMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminChangeUserEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListStartupsQueryKey = (options) => createQueryKey('v2AdminListStartups', options);
/**
 * List all startups (admin)
 */
export const v2AdminListStartupsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupsQueryKey(options)
});
export const v2AdminListStartupsInfiniteQueryKey = (options) => createQueryKey('v2AdminListStartups', options, true);
/**
 * List all startups (admin)
 */
export const v2AdminListStartupsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListStartups({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupsInfiniteQueryKey(options)
});
/**
 * Set the daily profile-chat answer ceiling for a startup (null = default)
 */
export const v2AdminSetStartupProfileChatLimitMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminSetStartupProfileChatLimit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListInvestorChecksQueryKey = (options) => createQueryKey('v2AdminListInvestorChecks', options);
/**
 * List investor account checks by status, oldest first
 */
export const v2AdminListInvestorChecksOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListInvestorChecks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListInvestorChecksQueryKey(options)
});
export const v2AdminListInvestorChecksInfiniteQueryKey = (options) => createQueryKey('v2AdminListInvestorChecks', options, true);
/**
 * List investor account checks by status, oldest first
 */
export const v2AdminListInvestorChecksInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListInvestorChecks({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListInvestorChecksInfiniteQueryKey(options)
});
/**
 * Pass or fail one investor account check; the first pass may award a founding place
 */
export const v2AdminDecideInvestorCheckMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDecideInvestorCheck({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListStartupFactsQueryKey = (options) => createQueryKey('v2AdminListStartupFacts', options);
/**
 * List the dated facts on a startup record, current or historic
 */
export const v2AdminListStartupFactsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartupFacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupFactsQueryKey(options)
});
export const v2AdminListStartupFactsInfiniteQueryKey = (options) => createQueryKey('v2AdminListStartupFacts', options, true);
/**
 * List the dated facts on a startup record, current or historic
 */
export const v2AdminListStartupFactsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListStartupFacts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupFactsInfiniteQueryKey(options)
});
export const v2AdminGetStartupEmailUpdatesQueryKey = (options) => createQueryKey('v2AdminGetStartupEmailUpdates', options);
/**
 * A startup's updates address, the updates received by email and the mail held
 */
export const v2AdminGetStartupEmailUpdatesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupEmailUpdates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupEmailUpdatesQueryKey(options)
});
export const v2AdminListStartupFactSourcesQueryKey = (options) => createQueryKey('v2AdminListStartupFactSources', options);
/**
 * List the documents and sessions the fact scan reads, with scan status
 */
export const v2AdminListStartupFactSourcesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartupFactSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupFactSourcesQueryKey(options)
});
/**
 * Queue one source for another fact scan
 */
export const v2AdminRescanStartupFactSourceMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRescanStartupFactSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Mark a startup as SeedForge's own test or demo startup (never discoverable)
 */
export const v2AdminSetStartupInternalMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminSetStartupInternal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListStartupCreditsQueryKey = (options) => createQueryKey('v2AdminListStartupCredits', options);
/**
 * List startup credit transactions (admin)
 */
export const v2AdminListStartupCreditsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartupCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupCreditsQueryKey(options)
});
/**
 * Add credits to startup (admin)
 */
export const v2AdminAddStartupCreditsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminAddStartupCredits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetStartupBillingQueryKey = (options) => createQueryKey('v2AdminGetStartupBilling', options);
/**
 * Get pay-as-you-go billing status for a startup (admin)
 */
export const v2AdminGetStartupBillingOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupBilling({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupBillingQueryKey(options)
});
/**
 * Grant free prepaid sessions or evaluations to a startup (admin)
 */
export const v2AdminGrantStartupUsageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminGrantStartupUsage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a startup unconsumed prepaid usage units (admin reset)
 */
export const v2AdminResetStartupGrantsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminResetStartupGrants({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetStartupDocumentsQueryKey = (options) => createQueryKey('v2AdminGetStartupDocuments', options);
/**
 * Get documents for a startup (admin)
 */
export const v2AdminGetStartupDocumentsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupDocumentsQueryKey(options)
});
export const v2AdminGetStartupMembershipsQueryKey = (options) => createQueryKey('v2AdminGetStartupMemberships', options);
/**
 * Get startup memberships (admin)
 */
export const v2AdminGetStartupMembershipsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupMemberships({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupMembershipsQueryKey(options)
});
export const v2AdminGetStartupTeamMembersQueryKey = (options) => createQueryKey('v2AdminGetStartupTeamMembers', options);
/**
 * Get startup team members (admin)
 */
export const v2AdminGetStartupTeamMembersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupTeamMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupTeamMembersQueryKey(options)
});
export const v2AdminListStartupMatchesQueryKey = (options) => createQueryKey('v2AdminListStartupMatches', options);
/**
 * List recommended investors for a startup (admin)
 */
export const v2AdminListStartupMatchesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartupMatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupMatchesQueryKey(options)
});
export const v2AdminListStartupMatchesInfiniteQueryKey = (options) => createQueryKey('v2AdminListStartupMatches', options, true);
/**
 * List recommended investors for a startup (admin)
 */
export const v2AdminListStartupMatchesInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListStartupMatches({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupMatchesInfiniteQueryKey(options)
});
export const v2AdminGetStartupOutreachStatusQueryKey = (options) => createQueryKey('v2AdminGetStartupOutreachStatus', options);
/**
 * Get outreach status for a startup (admin)
 */
export const v2AdminGetStartupOutreachStatusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupOutreachStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupOutreachStatusQueryKey(options)
});
export const v2AdminGetStartupOutreachHeyReachDebugQueryKey = (options) => createQueryKey('v2AdminGetStartupOutreachHeyReachDebug', options);
/**
 * Get HeyReach campaign/sender/invitation debug fields for a startup (admin)
 */
export const v2AdminGetStartupOutreachHeyReachDebugOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupOutreachHeyReachDebug({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupOutreachHeyReachDebugQueryKey(options)
});
/**
 * Force-disconnect a live outreach campaign after confirming its HeyReach workspace was deleted, blocking recreation
 */
export const v2AdminForceDisconnectStartupOutreachMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminForceDisconnectStartupOutreach({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetStartupOutreachOverviewQueryKey = (options) => createQueryKey('v2AdminGetStartupOutreachOverview', options);
/**
 * Get outreach KPI/funnel/last-sync for a startup (admin)
 */
export const v2AdminGetStartupOutreachOverviewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupOutreachOverview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupOutreachOverviewQueryKey(options)
});
export const v2AdminGetStartupPortfolioOutreachStatusQueryKey = (options) => createQueryKey('v2AdminGetStartupPortfolioOutreachStatus', options);
/**
 * Get portfolio outreach status for a startup (admin)
 */
export const v2AdminGetStartupPortfolioOutreachStatusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupPortfolioOutreachStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupPortfolioOutreachStatusQueryKey(options)
});
export const v2AdminGetStartupPortfolioOutreachQueueQueryKey = (options) => createQueryKey('v2AdminGetStartupPortfolioOutreachQueue', options);
/**
 * Get portfolio outreach queue for a startup (admin)
 */
export const v2AdminGetStartupPortfolioOutreachQueueOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupPortfolioOutreachQueue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupPortfolioOutreachQueueQueryKey(options)
});
export const v2AdminGetStartupOutreachContactsQueryKey = (options) => createQueryKey('v2AdminGetStartupOutreachContacts', options);
/**
 * Pass-through to engine outreach/contacts feed (admin export source)
 */
export const v2AdminGetStartupOutreachContactsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupOutreachContacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupOutreachContactsQueryKey(options)
});
export const v2AdminGetStartupOutreachContactsInfiniteQueryKey = (options) => createQueryKey('v2AdminGetStartupOutreachContacts', options, true);
/**
 * Pass-through to engine outreach/contacts feed (admin export source)
 */
export const v2AdminGetStartupOutreachContactsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminGetStartupOutreachContacts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupOutreachContactsInfiniteQueryKey(options)
});
/**
 * Regenerate one or more of msg1/msg2/msg3 independently via per-message Langfuse prompts.
 */
export const v2AdminRegenerateContactMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRegenerateContactMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Regenerate one or more of the per-startup msg1/msg2/msg3 sequence independently.
 */
export const v2AdminRegenerateStartupMessagesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRegenerateStartupMessages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Regenerate one or more of the per-startup portfolio msg1/msg2/msg3 sequence.
 */
export const v2AdminRegeneratePortfolioMessagesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRegeneratePortfolioMessages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetStartupMatchesRefreshStatusQueryKey = (options) => createQueryKey('v2AdminGetStartupMatchesRefreshStatus', options);
/**
 * Get the latest matcher refresh request for a startup (admin)
 */
export const v2AdminGetStartupMatchesRefreshStatusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupMatchesRefreshStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupMatchesRefreshStatusQueryKey(options)
});
/**
 * Enqueue a matcher refresh for a startup (admin)
 *
 * Inserts a PENDING StartupMatchRefreshRequest. The engine scheduler picks it up and runs the matcher pipeline. Idempotent: if a request is already PENDING/PROCESSING, returns it.
 */
export const v2AdminRefreshStartupMatchesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRefreshStartupMatches({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Schedule LinkedIn scrape for all team members missing raw data (admin)
 *
 * Finds team members with a LinkedIn URL but no rawLinkedInData (and not already SCRAPING) and triggers an async scrape for each. Returns immediately with the count of scheduled scrapes. Progress is visible via linkedinScrapeStatus on each member.
 */
export const v2AdminBackfillTeamMemberLinkedInMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminBackfillTeamMemberLinkedIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListInvestorsQueryKey = (options) => createQueryKey('v2AdminListInvestors', options);
/**
 * List all investors (admin)
 */
export const v2AdminListInvestorsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListInvestors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListInvestorsQueryKey(options)
});
export const v2AdminListInvestorsInfiniteQueryKey = (options) => createQueryKey('v2AdminListInvestors', options, true);
/**
 * List all investors (admin)
 */
export const v2AdminListInvestorsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListInvestors({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListInvestorsInfiniteQueryKey(options)
});
export const v2AdminGetInvestorByIdQueryKey = (options) => createQueryKey('v2AdminGetInvestorById', options);
/**
 * Get investor by ID (admin)
 */
export const v2AdminGetInvestorByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetInvestorById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetInvestorByIdQueryKey(options)
});
/**
 * Update investor type / inactive-until (admin)
 */
export const v2AdminUpdateInvestorMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminUpdateInvestor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListInvestorUpdateProposalsQueryKey = (options) => createQueryKey('v2AdminListInvestorUpdateProposals', options);
/**
 * List proposed investor/contact outreach exclusions (admin)
 */
export const v2AdminListInvestorUpdateProposalsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListInvestorUpdateProposals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListInvestorUpdateProposalsQueryKey(options)
});
export const v2AdminListInvestorUpdateProposalsInfiniteQueryKey = (options) => createQueryKey('v2AdminListInvestorUpdateProposals', options, true);
/**
 * List proposed investor/contact outreach exclusions (admin)
 */
export const v2AdminListInvestorUpdateProposalsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListInvestorUpdateProposals({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListInvestorUpdateProposalsInfiniteQueryKey(options)
});
/**
 * Approve or reject an investor update proposal (admin)
 */
export const v2AdminDecideInvestorUpdateProposalMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDecideInvestorUpdateProposal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Pause or resume one contact's outreach (admin)
 */
export const v2AdminPauseInvestorContactMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminPauseInvestorContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListInvestorDealFlowInteractionsQueryKey = (options) => createQueryKey('v2AdminListInvestorDealFlowInteractions', options);
/**
 * List deal flow pass/connect actions for an investor
 */
export const v2AdminListInvestorDealFlowInteractionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListInvestorDealFlowInteractions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListInvestorDealFlowInteractionsQueryKey(options)
});
export const v2AdminListStartupDealFlowInteractionsQueryKey = (options) => createQueryKey('v2AdminListStartupDealFlowInteractions', options);
/**
 * List deal flow pass/connect actions investors made on a startup
 */
export const v2AdminListStartupDealFlowInteractionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartupDealFlowInteractions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupDealFlowInteractionsQueryKey(options)
});
export const v2AdminListInvestorDealFlowMatchesQueryKey = (options) => createQueryKey('v2AdminListInvestorDealFlowMatches', options);
/**
 * List persisted deal-flow startup matches for an investor (admin)
 */
export const v2AdminListInvestorDealFlowMatchesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListInvestorDealFlowMatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListInvestorDealFlowMatchesQueryKey(options)
});
/**
 * Enqueue a deal-flow matches refresh request for an investor
 */
export const v2AdminRefreshInvestorDealFlowMatchesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRefreshInvestorDealFlowMatches({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Send a test deal-flow digest email to all investor team members
 */
export const v2AdminSendInvestorDealFlowDigestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminSendInvestorDealFlowDigest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListUnknownInvestorPreferencesQueryKey = (options) => createQueryKey('v2AdminListUnknownInvestorPreferences', options);
/**
 * List free-form investor preference values not in the canonical enums
 */
export const v2AdminListUnknownInvestorPreferencesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListUnknownInvestorPreferences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListUnknownInvestorPreferencesQueryKey(options)
});
/**
 * Apply an admin-provided dictionary + drop unknowns across all investor preferences. Dry-run by default.
 */
export const v2AdminNormalizeInvestorPreferencesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminNormalizeInvestorPreferences({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetInvestorPersonaQueryKey = (options) => createQueryKey('v2AdminGetInvestorPersona', options);
/**
 * Get investor persona with metric prompts (admin)
 */
export const v2AdminGetInvestorPersonaOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetInvestorPersona({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetInvestorPersonaQueryKey(options)
});
/**
 * Trigger persona research for investor (admin)
 */
export const v2AdminTriggerPersonaResearchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminTriggerPersonaResearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Trigger activity research for investor (admin)
 */
export const v2AdminTriggerActivityResearchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminTriggerActivityResearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListActivityResearchQueryKey = (options) => createQueryKey('v2AdminListActivityResearch', options);
/**
 * List all activity research jobs (admin)
 */
export const v2AdminListActivityResearchOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListActivityResearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListActivityResearchQueryKey(options)
});
export const v2AdminListActivityResearchInfiniteQueryKey = (options) => createQueryKey('v2AdminListActivityResearch', options, true);
/**
 * List all activity research jobs (admin)
 */
export const v2AdminListActivityResearchInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListActivityResearch({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListActivityResearchInfiniteQueryKey(options)
});
export const v2AdminListPersonaResearchQueryKey = (options) => createQueryKey('v2AdminListPersonaResearch', options);
/**
 * List all persona research jobs (admin)
 */
export const v2AdminListPersonaResearchOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListPersonaResearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListPersonaResearchQueryKey(options)
});
export const v2AdminListPersonaResearchInfiniteQueryKey = (options) => createQueryKey('v2AdminListPersonaResearch', options, true);
/**
 * List all persona research jobs (admin)
 */
export const v2AdminListPersonaResearchInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListPersonaResearch({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListPersonaResearchInfiniteQueryKey(options)
});
/**
 * Trigger portfolio research for investor (admin)
 */
export const v2AdminTriggerPortfolioResearchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminTriggerPortfolioResearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListPortfolioResearchQueryKey = (options) => createQueryKey('v2AdminListPortfolioResearch', options);
/**
 * List portfolio research jobs (admin)
 */
export const v2AdminListPortfolioResearchOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListPortfolioResearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListPortfolioResearchQueryKey(options)
});
export const v2AdminListPortfolioResearchInfiniteQueryKey = (options) => createQueryKey('v2AdminListPortfolioResearch', options, true);
/**
 * List portfolio research jobs (admin)
 */
export const v2AdminListPortfolioResearchInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListPortfolioResearch({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListPortfolioResearchInfiniteQueryKey(options)
});
export const v2AdminGetInvestorPortfolioCompaniesQueryKey = (options) => createQueryKey('v2AdminGetInvestorPortfolioCompanies', options);
/**
 * Get portfolio companies and contacts for investor (admin)
 */
export const v2AdminGetInvestorPortfolioCompaniesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetInvestorPortfolioCompanies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetInvestorPortfolioCompaniesQueryKey(options)
});
export const v2AdminGetOutreachCopyArmsQueryKey = (options) => createQueryKey('v2AdminGetOutreachCopyArms', options);
/**
 * Per-startup outcomes by outreach copy arm, with excluded counts
 */
export const v2AdminGetOutreachCopyArmsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetOutreachCopyArms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetOutreachCopyArmsQueryKey(options)
});
export const v2AdminGetStartupOutreachVariantsQueryKey = (options) => createQueryKey('v2AdminGetStartupOutreachVariants', options);
/**
 * Every live message variant for a startup, both campaigns
 */
export const v2AdminGetStartupOutreachVariantsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetStartupOutreachVariants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetStartupOutreachVariantsQueryKey(options)
});
export const v2AdminGetWarmIntroCandidatesQueryKey = (options) => createQueryKey('v2AdminGetWarmIntroCandidates', options);
/**
 * List open portfolio warm-intro candidates for confirmation
 */
export const v2AdminGetWarmIntroCandidatesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetWarmIntroCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetWarmIntroCandidatesQueryKey(options)
});
export const v2AdminListOutreachReplyClassificationQueryKey = (options) => createQueryKey('v2AdminListOutreachReplyClassification', options);
/**
 * List outreach reply classification jobs (admin)
 */
export const v2AdminListOutreachReplyClassificationOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListOutreachReplyClassification({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListOutreachReplyClassificationQueryKey(options)
});
export const v2AdminListOutreachReplyClassificationInfiniteQueryKey = (options) => createQueryKey('v2AdminListOutreachReplyClassification', options, true);
/**
 * List outreach reply classification jobs (admin)
 */
export const v2AdminListOutreachReplyClassificationInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListOutreachReplyClassification({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListOutreachReplyClassificationInfiniteQueryKey(options)
});
export const v2AdminGetOutreachReplyStatsQueryKey = (options) => createQueryKey('v2AdminGetOutreachReplyStats', options);
/**
 * Global reply classification stats for all startups (7d/30d)
 */
export const v2AdminGetOutreachReplyStatsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetOutreachReplyStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetOutreachReplyStatsQueryKey(options)
});
export const v2AdminGetOutreachMessageConversationQueryKey = (options) => createQueryKey('v2AdminGetOutreachMessageConversation', options);
/**
 * Read the live LinkedIn conversation for a message (admin, never stored)
 */
export const v2AdminGetOutreachMessageConversationOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetOutreachMessageConversation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetOutreachMessageConversationQueryKey(options)
});
/**
 * Rerun a reply classification job (admin)
 */
export const v2AdminRerunOutreachReplyClassificationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRerunOutreachReplyClassification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Rerun a portfolio reply classification job (admin)
 */
export const v2AdminRerunPortfolioOutreachReplyClassificationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRerunPortfolioOutreachReplyClassification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListMatcherJobsQueryKey = (options) => createQueryKey('v2AdminListMatcherJobs', options);
/**
 * List all matcher refresh jobs across startups (admin)
 */
export const v2AdminListMatcherJobsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListMatcherJobs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListMatcherJobsQueryKey(options)
});
export const v2AdminListMatcherJobsInfiniteQueryKey = (options) => createQueryKey('v2AdminListMatcherJobs', options, true);
/**
 * List all matcher refresh jobs across startups (admin)
 */
export const v2AdminListMatcherJobsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListMatcherJobs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListMatcherJobsInfiniteQueryKey(options)
});
export const v2AdminListInvestorCreditsQueryKey = (options) => createQueryKey('v2AdminListInvestorCredits', options);
/**
 * List investor credit transactions (admin)
 */
export const v2AdminListInvestorCreditsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListInvestorCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListInvestorCreditsQueryKey(options)
});
/**
 * Add credits to investor (admin)
 */
export const v2AdminAddInvestorCreditsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminAddInvestorCredits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetInvestorMembershipsQueryKey = (options) => createQueryKey('v2AdminGetInvestorMemberships', options);
/**
 * Get investor memberships (admin)
 */
export const v2AdminGetInvestorMembershipsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetInvestorMemberships({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetInvestorMembershipsQueryKey(options)
});
export const v2AdminListEvaluationsQueryKey = (options) => createQueryKey('v2AdminListEvaluations', options);
/**
 * List all evaluations (pitch + prescreen) unified
 */
export const v2AdminListEvaluationsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListEvaluations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListEvaluationsQueryKey(options)
});
export const v2AdminListEvaluationsInfiniteQueryKey = (options) => createQueryKey('v2AdminListEvaluations', options, true);
/**
 * List all evaluations (pitch + prescreen) unified
 */
export const v2AdminListEvaluationsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListEvaluations({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListEvaluationsInfiniteQueryKey(options)
});
export const v2AdminGetEvaluationViewQueryKey = (options) => createQueryKey('v2AdminGetEvaluationView', options);
/**
 * Get evaluation in view format (same as founder detail)
 */
export const v2AdminGetEvaluationViewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetEvaluationView({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetEvaluationViewQueryKey(options)
});
export const v2AdminGetEvaluationDetailsQueryKey = (options) => createQueryKey('v2AdminGetEvaluationDetails', options);
/**
 * Get single evaluation raw details with research data
 */
export const v2AdminGetEvaluationDetailsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetEvaluationDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetEvaluationDetailsQueryKey(options)
});
export const v2AdminGetJudgeProfileQueryKey = (options) => createQueryKey('v2AdminGetJudgeProfile', options);
/**
 * Get judge profile for an evaluation (admin)
 */
export const v2AdminGetJudgeProfileOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetJudgeProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetJudgeProfileQueryKey(options)
});
/**
 * Regenerate evaluation for a pitch session (admin)
 */
export const v2AdminRegenerateEvaluationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRegenerateEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Rerun prescreen with a selected document (admin)
 */
export const v2AdminRerunPrescreenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRerunPrescreen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Trigger a prescreen for a startup with a linked pitch deck (admin)
 */
export const v2AdminTriggerPrescreenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminTriggerPrescreen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a prescreen request and its evaluations (admin)
 */
export const v2AdminDeletePrescreenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeletePrescreen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a pitch session and all its evaluations (admin)
 */
export const v2AdminDeletePitchSessionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeletePitchSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a single evaluation (admin)
 */
export const v2AdminDeleteEvaluationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeleteEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListDataRoomsQueryKey = (options) => createQueryKey('v2AdminListDataRooms', options);
/**
 * List all data rooms (admin)
 */
export const v2AdminListDataRoomsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListDataRooms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListDataRoomsQueryKey(options)
});
export const v2AdminListDataRoomsInfiniteQueryKey = (options) => createQueryKey('v2AdminListDataRooms', options, true);
/**
 * List all data rooms (admin)
 */
export const v2AdminListDataRoomsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListDataRooms({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListDataRoomsInfiniteQueryKey(options)
});
export const v2AdminGetDataRoomByIdQueryKey = (options) => createQueryKey('v2AdminGetDataRoomById', options);
/**
 * Get data room by ID with content (admin)
 */
export const v2AdminGetDataRoomByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetDataRoomById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetDataRoomByIdQueryKey(options)
});
export const v2AdminGetDataRoomAnalyticsQueryKey = (options) => createQueryKey('v2AdminGetDataRoomAnalytics', options);
/**
 * Get data room analytics (admin)
 */
export const v2AdminGetDataRoomAnalyticsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetDataRoomAnalytics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetDataRoomAnalyticsQueryKey(options)
});
export const v2AdminListAiInsightReportsQueryKey = (options) => createQueryKey('v2AdminListAiInsightReports', options);
/**
 * List latest AI insight reports per startup (admin)
 */
export const v2AdminListAiInsightReportsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListAiInsightReports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListAiInsightReportsQueryKey(options)
});
/**
 * Manually regenerate the AI insight report for a startup (admin)
 */
export const v2AdminRegenerateAiInsightReportMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRegenerateAiInsightReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListStartupTextFeedbacksQueryKey = (options) => createQueryKey('v2AdminListStartupTextFeedbacks', options);
/**
 * List text highlight feedbacks for a startup
 */
export const v2AdminListStartupTextFeedbacksOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartupTextFeedbacks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupTextFeedbacksQueryKey(options)
});
export const v2AdminListStartupReactionsQueryKey = (options) => createQueryKey('v2AdminListStartupReactions', options);
/**
 * List statement reactions (agree/disagree) for a startup
 */
export const v2AdminListStartupReactionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartupReactions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupReactionsQueryKey(options)
});
export const v2AdminListProfileChatsQueryKey = (options) => createQueryKey('v2AdminListProfileChats', options);
/**
 * List profile chat conversations (admin)
 */
export const v2AdminListProfileChatsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListProfileChats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListProfileChatsQueryKey(options)
});
export const v2AdminListProfileChatsInfiniteQueryKey = (options) => createQueryKey('v2AdminListProfileChats', options, true);
/**
 * List profile chat conversations (admin)
 */
export const v2AdminListProfileChatsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListProfileChats({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListProfileChatsInfiniteQueryKey(options)
});
export const v2AdminGetProfileChatByIdQueryKey = (options) => createQueryKey('v2AdminGetProfileChatById', options);
/**
 * Get one profile chat conversation with every turn (admin)
 */
export const v2AdminGetProfileChatByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetProfileChatById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetProfileChatByIdQueryKey(options)
});
export const v2AdminGetProfileChatTurnContextQueryKey = (options) => createQueryKey('v2AdminGetProfileChatTurnContext', options);
/**
 * Everything the model received for one profile chat turn (admin)
 */
export const v2AdminGetProfileChatTurnContextOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetProfileChatTurnContext({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetProfileChatTurnContextQueryKey(options)
});
/**
 * Drop the question text of one profile chat turn (admin)
 */
export const v2AdminRedactProfileChatTurnMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRedactProfileChatTurn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListFeedbackQueryKey = (options) => createQueryKey('v2AdminListFeedback', options);
/**
 * List all feedback (admin)
 */
export const v2AdminListFeedbackOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListFeedbackQueryKey(options)
});
export const v2AdminListFeedbackInfiniteQueryKey = (options) => createQueryKey('v2AdminListFeedback', options, true);
/**
 * List all feedback (admin)
 */
export const v2AdminListFeedbackInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListFeedback({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListFeedbackInfiniteQueryKey(options)
});
export const v2AdminListAutomatedEmailsQueryKey = (options) => createQueryKey('v2AdminListAutomatedEmails', options);
/**
 * List all automated emails (admin)
 */
export const v2AdminListAutomatedEmailsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListAutomatedEmails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListAutomatedEmailsQueryKey(options)
});
export const v2AdminListAutomatedEmailsInfiniteQueryKey = (options) => createQueryKey('v2AdminListAutomatedEmails', options, true);
/**
 * List all automated emails (admin)
 */
export const v2AdminListAutomatedEmailsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListAutomatedEmails({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListAutomatedEmailsInfiniteQueryKey(options)
});
export const v2AdminGetAutomatedEmailByIdQueryKey = (options) => createQueryKey('v2AdminGetAutomatedEmailById', options);
/**
 * Get automated email by ID (admin)
 */
export const v2AdminGetAutomatedEmailByIdOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetAutomatedEmailById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetAutomatedEmailByIdQueryKey(options)
});
/**
 * Manually send a pending automated email (admin)
 */
export const v2AdminSendAutomatedEmailMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminSendAutomatedEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListStartupEntitlementsQueryKey = (options) => createQueryKey('v2AdminListStartupEntitlements', options);
/**
 * List entitlements for a startup (history + status)
 */
export const v2AdminListStartupEntitlementsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStartupEntitlements({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStartupEntitlementsQueryKey(options)
});
/**
 * Grant a non-consumable entitlement to a startup (no Stripe activity)
 */
export const v2AdminGrantStartupEntitlementMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminGrantStartupEntitlement({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Revoke an entitlement (audit-only; refund the Stripe charge separately if PURCHASE)
 */
export const v2AdminRevokeStartupEntitlementMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRevokeStartupEntitlement({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListPendingOutreachQueryKey = (options) => createQueryKey('v2AdminListPendingOutreach', options);
/**
 * List outreach rows awaiting campaign clone
 */
export const v2AdminListPendingOutreachOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListPendingOutreach({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListPendingOutreachQueryKey(options)
});
export const v2AdminListOutreachLimitsPendingQueryKey = (options) => createQueryKey('v2AdminListOutreachLimitsPending', options);
/**
 * List live outreach campaigns whose HeyReach sending limits are not yet confirmed
 */
export const v2AdminListOutreachLimitsPendingOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListOutreachLimitsPending({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListOutreachLimitsPendingQueryKey(options)
});
/**
 * Confirm the HeyReach sending limits are set; stamps limitsUpdatedAt
 */
export const v2AdminMarkOutreachLimitsSetMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminMarkOutreachLimitsSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListOutreachWithdrawalRequestsQueryKey = (options) => createQueryKey('v2AdminListOutreachWithdrawalRequests', options);
/**
 * List pending founder outreach wallet withdrawal requests
 */
export const v2AdminListOutreachWithdrawalRequestsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListOutreachWithdrawalRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListOutreachWithdrawalRequestsQueryKey(options)
});
/**
 * Mark a withdrawal request resolved once the refund is processed
 */
export const v2AdminResolveOutreachWithdrawalRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminResolveOutreachWithdrawalRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListOutreachSeatQueueQueryKey = (options) => createQueryKey('v2AdminListOutreachSeatQueue', options);
/**
 * List startups using outreach (provisioned seats)
 */
export const v2AdminListOutreachSeatQueueOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListOutreachSeatQueue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListOutreachSeatQueueQueryKey(options)
});
/**
 * Force-promote a PENDING_SEAT outreach (bypasses cap)
 */
export const v2AdminPromoteOutreachSeatMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminPromoteOutreachSeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Force a single-row sender/campaign re-poll
 */
export const v2AdminRecheckOutreachMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRecheckOutreach({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Reclaim an outreach seat (pause + remove member)
 */
export const v2AdminEjectOutreachSeatMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminEjectOutreachSeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListStuckAwaitingSenderOutreachQueryKey = (options) => createQueryKey('v2AdminListStuckAwaitingSenderOutreach', options);
/**
 * List outreach rows stuck in AWAITING_SENDER for over 2 weeks
 */
export const v2AdminListStuckAwaitingSenderOutreachOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListStuckAwaitingSenderOutreach({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListStuckAwaitingSenderOutreachQueryKey(options)
});
export const v2AdminListOutreachStartupMetricsQueryKey = (options) => createQueryKey('v2AdminListOutreachStartupMetrics', options);
/**
 * Per-startup match quality and interaction breakdown for outreach
 */
export const v2AdminListOutreachStartupMetricsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListOutreachStartupMetrics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListOutreachStartupMetricsQueryKey(options)
});
/**
 * Live-check HeyReach to confirm a stuck workspace was manually deleted
 */
export const v2AdminRecheckOutreachWorkspaceRemovedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRecheckOutreachWorkspaceRemoved({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Clear a stuck outreach workspace after confirming its HeyReach workspace was deleted, blocking recreation
 */
export const v2AdminResetStuckOutreachWorkspaceMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminResetStuckOutreachWorkspace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListOutreachCallCandidatesQueryKey = (options) => createQueryKey('v2AdminListOutreachCallCandidates', options);
/**
 * List replies flagged by the LLM as potential booked calls or investor warm intros (admin must decide)
 */
export const v2AdminListOutreachCallCandidatesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListOutreachCallCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListOutreachCallCandidatesQueryKey(options)
});
export const v2AdminListManualCallBookingCandidatesQueryKey = (options) => createQueryKey('v2AdminListManualCallBookingCandidates', options);
/**
 * List outreach messages eligible for manual call booking
 */
export const v2AdminListManualCallBookingCandidatesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListManualCallBookingCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListManualCallBookingCandidatesQueryKey(options)
});
export const v2AdminListOutreachBillingQueryKey = (options) => createQueryKey('v2AdminListOutreachBilling', options);
/**
 * List all outreach campaigns with wallet + spend summary
 */
export const v2AdminListOutreachBillingOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListOutreachBilling({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListOutreachBillingQueryKey(options)
});
export const v2AdminGetOutreachBillingDetailQueryKey = (options) => createQueryKey('v2AdminGetOutreachBillingDetail', options);
/**
 * Outreach billing detail for one startup (transactions + accruals)
 */
export const v2AdminGetOutreachBillingDetailOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetOutreachBillingDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetOutreachBillingDetailQueryKey(options)
});
/**
 * Issue a manual outreach refund or balance adjustment
 */
export const v2AdminCreateOutreachCreditTransactionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminCreateOutreachCreditTransaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Confirm or dismiss an LLM-flagged call candidate
 */
export const v2AdminOutreachCallDecisionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminOutreachCallDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetInvestorThesisQueryKey = (options) => createQueryKey('v2AdminGetInvestorThesis', options);
/**
 * The thesis each member of an investor's firm set through their AI assistant
 */
export const v2AdminGetInvestorThesisOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetInvestorThesis({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetInvestorThesisQueryKey(options)
});
/**
 * Pin an investor to one MCP text set (null routes on the app again)
 */
export const v2AdminSetMcpTextSetMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminSetMcpTextSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListObserversQueryKey = (options) => createQueryKey('v2AdminListObservers', options);
/**
 * List investor follows with state and classification, never their words
 */
export const v2AdminListObserversOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListObservers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListObserversQueryKey(options)
});
export const v2AdminListObserversInfiniteQueryKey = (options) => createQueryKey('v2AdminListObservers', options, true);
/**
 * List investor follows with state and classification, never their words
 */
export const v2AdminListObserversInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListObservers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListObserversInfiniteQueryKey(options)
});
export const v2AdminListObserverAlertsQueryKey = (options) => createQueryKey('v2AdminListObserverAlerts', options);
/**
 * The founder statements that fired a follow's alerts, never the investor's words
 */
export const v2AdminListObserverAlertsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListObserverAlerts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListObserverAlertsQueryKey(options)
});
export const v2AdminAgentOverviewQueryKey = (options) => createQueryKey('v2AdminAgentOverview', options);
/**
 * Investor AI call metrics, sessions and engine job health (never arguments)
 */
export const v2AdminAgentOverviewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminAgentOverview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminAgentOverviewQueryKey(options)
});
export const v2AdminAgentOverviewInfiniteQueryKey = (options) => createQueryKey('v2AdminAgentOverview', options, true);
/**
 * Investor AI call metrics, sessions and engine job health (never arguments)
 */
export const v2AdminAgentOverviewInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminAgentOverview({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminAgentOverviewInfiniteQueryKey(options)
});
export const v2AdminAgentClientsQueryKey = (options) => createQueryKey('v2AdminAgentClients', options);
/**
 * Every app that has called the MCP, with its first-seen date and latest text set
 */
export const v2AdminAgentClientsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminAgentClients({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminAgentClientsQueryKey(options)
});
export const v2AdminAgentSessionCallsQueryKey = (options) => createQueryKey('v2AdminAgentSessionCalls', options);
/**
 * The calls of one agent session: tool, latency, status, refusal, time
 */
export const v2AdminAgentSessionCallsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminAgentSessionCalls({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminAgentSessionCallsQueryKey(options)
});
export const v2AdminListBlogPostsQueryKey = (options) => createQueryKey('v2AdminListBlogPosts', options);
/**
 * List all blog posts (admin)
 */
export const v2AdminListBlogPostsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListBlogPosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListBlogPostsQueryKey(options)
});
export const v2AdminListBlogPostsInfiniteQueryKey = (options) => createQueryKey('v2AdminListBlogPosts', options, true);
/**
 * List all blog posts (admin)
 */
export const v2AdminListBlogPostsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2AdminListBlogPosts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListBlogPostsInfiniteQueryKey(options)
});
/**
 * Create a new blog post
 */
export const v2AdminCreateBlogPostMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminCreateBlogPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a blog post
 */
export const v2AdminDeleteBlogPostMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeleteBlogPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetBlogPostQueryKey = (options) => createQueryKey('v2AdminGetBlogPost', options);
/**
 * Get blog post by ID (admin)
 */
export const v2AdminGetBlogPostOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetBlogPost({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetBlogPostQueryKey(options)
});
/**
 * Update a blog post
 */
export const v2AdminUpdateBlogPostMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminUpdateBlogPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListPublishedBlogPostsQueryKey = (options) => createQueryKey('v2ListPublishedBlogPosts', options);
/**
 * List published blog posts
 */
export const v2ListPublishedBlogPostsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListPublishedBlogPosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListPublishedBlogPostsQueryKey(options)
});
export const v2ListPublishedBlogPostsInfiniteQueryKey = (options) => createQueryKey('v2ListPublishedBlogPosts', options, true);
/**
 * List published blog posts
 */
export const v2ListPublishedBlogPostsInfiniteOptions = (options) => infiniteQueryOptions(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await v2ListPublishedBlogPosts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListPublishedBlogPostsInfiniteQueryKey(options)
});
export const v2GetPublishedBlogPostQueryKey = (options) => createQueryKey('v2GetPublishedBlogPost', options);
/**
 * Get a published blog post by slug
 */
export const v2GetPublishedBlogPostOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPublishedBlogPost({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPublishedBlogPostQueryKey(options)
});
/**
 * Publish a certified Active Investor Index feed
 */
export const v2AdminPublishInvestorIndexMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminPublishInvestorIndex({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetInvestorIndexStatusQueryKey = (options) => createQueryKey('v2AdminGetInvestorIndexStatus', options);
/**
 * Page counts and recent publications of the Active Investor Index
 */
export const v2AdminGetInvestorIndexStatusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetInvestorIndexStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetInvestorIndexStatusQueryKey(options)
});
export const v2ListInvestorIndexPagesQueryKey = (options) => createQueryKey('v2ListInvestorIndexPages', options);
/**
 * List published Active Investor Index pages (summaries only)
 */
export const v2ListInvestorIndexPagesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListInvestorIndexPages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListInvestorIndexPagesQueryKey(options)
});
export const v2GetInvestorIndexPageQueryKey = (options) => createQueryKey('v2GetInvestorIndexPage', options);
/**
 * Get one published Active Investor Index page by key
 */
export const v2GetInvestorIndexPageOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetInvestorIndexPage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetInvestorIndexPageQueryKey(options)
});
export const v2AdminListEmailTemplatesQueryKey = (options) => createQueryKey('v2AdminListEmailTemplates', options);
/**
 * List all automated email templates
 */
export const v2AdminListEmailTemplatesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListEmailTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListEmailTemplatesQueryKey(options)
});
export const v2AdminGetEmailTemplateQueryKey = (options) => createQueryKey('v2AdminGetEmailTemplate', options);
/**
 * Get an email template by type
 */
export const v2AdminGetEmailTemplateOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetEmailTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetEmailTemplateQueryKey(options)
});
/**
 * Update an email template (subject, body, enabled)
 */
export const v2AdminUpdateEmailTemplateMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminUpdateEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Send a test render of an email template to the admin's own email
 */
export const v2AdminSendTestEmailTemplateMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminSendTestEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Record where a new account came from (first touch, written once)
 */
export const v2RecordSignupSourceMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RecordSignupSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Record the answer to the sign-up question, or a skip (written once)
 */
export const v2RecordSignupAnswerMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RecordSignupAnswer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetSignupQuestionQueryKey = (options) => createQueryKey('v2GetSignupQuestion', options);
/**
 * Get the sign-up question shown during onboarding
 */
export const v2GetSignupQuestionOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetSignupQuestion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetSignupQuestionQueryKey(options)
});
export const v2AdminGetSignupQuestionQueryKey = (options) => createQueryKey('v2AdminGetSignupQuestion', options);
/**
 * Get the sign-up question for editing
 */
export const v2AdminGetSignupQuestionOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetSignupQuestion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetSignupQuestionQueryKey(options)
});
/**
 * Save the sign-up question (title, options, follow-ups, AI question)
 */
export const v2AdminUpdateSignupQuestionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminUpdateSignupQuestion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminListHelpCategoriesQueryKey = (options) => createQueryKey('v2AdminListHelpCategories', options);
/**
 * List help center categories with their articles
 */
export const v2AdminListHelpCategoriesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListHelpCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListHelpCategoriesQueryKey(options)
});
/**
 * Create a help center category
 */
export const v2AdminCreateHelpCategoryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminCreateHelpCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Reorder help center categories
 */
export const v2AdminReorderHelpCategoriesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminReorderHelpCategories({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a help center category (must be empty)
 */
export const v2AdminDeleteHelpCategoryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeleteHelpCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Update a help center category
 */
export const v2AdminUpdateHelpCategoryMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminUpdateHelpCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListPublishedHelpCategoriesQueryKey = (options) => createQueryKey('v2ListPublishedHelpCategories', options);
/**
 * List published help categories with their articles
 */
export const v2ListPublishedHelpCategoriesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListPublishedHelpCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListPublishedHelpCategoriesQueryKey(options)
});
/**
 * Create a help center article
 */
export const v2AdminCreateHelpArticleMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminCreateHelpArticle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Reorder help center articles within a category
 */
export const v2AdminReorderHelpArticlesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminReorderHelpArticles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Delete a help center article
 */
export const v2AdminDeleteHelpArticleMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminDeleteHelpArticle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2AdminGetHelpArticleQueryKey = (options) => createQueryKey('v2AdminGetHelpArticle', options);
/**
 * Get help center article by ID
 */
export const v2AdminGetHelpArticleOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminGetHelpArticle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminGetHelpArticleQueryKey(options)
});
/**
 * Update a help center article
 */
export const v2AdminUpdateHelpArticleMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminUpdateHelpArticle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2SearchPublishedHelpArticlesQueryKey = (options) => createQueryKey('v2SearchPublishedHelpArticles', options);
/**
 * Search published help articles by title, description, and content
 */
export const v2SearchPublishedHelpArticlesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2SearchPublishedHelpArticles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2SearchPublishedHelpArticlesQueryKey(options)
});
export const v2GetPublishedHelpArticleQueryKey = (options) => createQueryKey('v2GetPublishedHelpArticle', options);
/**
 * Get a published help article by slug
 */
export const v2GetPublishedHelpArticleOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPublishedHelpArticle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPublishedHelpArticleQueryKey(options)
});
export const v2GetBillingStatusQueryKey = (options) => createQueryKey('v2GetBillingStatus', options);
/**
 * Get pay-as-you-go balances for a startup
 */
export const v2GetBillingStatusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetBillingStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetBillingStatusQueryKey(options)
});
export const v2GetDealFlowSubscriptionStatusQueryKey = (options) => createQueryKey('v2GetDealFlowSubscriptionStatus', options);
/**
 * Get the investor’s current deal flow subscription status
 */
export const v2GetDealFlowSubscriptionStatusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetDealFlowSubscriptionStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetDealFlowSubscriptionStatusQueryKey(options)
});
/**
 * Subscribe the investor to deal flow alerts
 */
export const v2SubscribeToDealFlowMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SubscribeToDealFlow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Unsubscribe the investor from deal flow alerts
 */
export const v2UnsubscribeFromDealFlowMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UnsubscribeFromDealFlow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2ListDealFlowMatchesQueryKey = (options) => createQueryKey('v2ListDealFlowMatches', options);
/**
 * List startups currently matched into the investor’s deal flow
 */
export const v2ListDealFlowMatchesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListDealFlowMatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListDealFlowMatchesQueryKey(options)
});
export const v2ListDealFlowArchiveQueryKey = (options) => createQueryKey('v2ListDealFlowArchive', options);
/**
 * List startups the investor has passed on or connected with
 */
export const v2ListDealFlowArchiveOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2ListDealFlowArchive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2ListDealFlowArchiveQueryKey(options)
});
export const v2GetDealFlowMatchQueryKey = (options) => createQueryKey('v2GetDealFlowMatch', options);
/**
 * Get a single deal flow match by startup id
 */
export const v2GetDealFlowMatchOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetDealFlowMatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetDealFlowMatchQueryKey(options)
});
/**
 * Generate short-lived URL for a deal flow startup’s pitch video
 */
export const v2GetDealFlowMatchVideoUrlMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2GetDealFlowMatchVideoUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Generate short-lived download URL for a deal flow startup’s document
 */
export const v2DownloadDealFlowMatchDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2DownloadDealFlowMatchDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Investor passes on a deal flow startup
 */
export const v2PassDealFlowMatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2PassDealFlowMatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Investor sends a connect request to a deal flow startup
 */
export const v2ConnectDealFlowMatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ConnectDealFlowMatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetActiveEntitlementsQueryKey = (options) => createQueryKey('v2GetActiveEntitlements', options);
/**
 * List active entitlements for a startup (locked/unlocked state)
 */
export const v2GetActiveEntitlementsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetActiveEntitlements({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetActiveEntitlementsQueryKey(options)
});
export const v2AdminListFeatureFlagsQueryKey = (options) => createQueryKey('v2AdminListFeatureFlags', options);
/**
 * List all registered feature flags with their allowlists (admin)
 */
export const v2AdminListFeatureFlagsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2AdminListFeatureFlags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2AdminListFeatureFlagsQueryKey(options)
});
/**
 * Toggle the global enabled state of a feature flag (admin)
 */
export const v2AdminSetFeatureFlagEnabledMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminSetFeatureFlagEnabled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Add a startup to a feature flag allowlist (admin)
 */
export const v2AdminAddFeatureFlagStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminAddFeatureFlagStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Remove a startup from a feature flag allowlist (admin)
 */
export const v2AdminRemoveFeatureFlagStartupMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRemoveFeatureFlagStartup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Add an investor to a feature flag allowlist (admin)
 */
export const v2AdminAddFeatureFlagInvestorMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminAddFeatureFlagInvestor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Remove an investor from a feature flag allowlist (admin)
 */
export const v2AdminRemoveFeatureFlagInvestorMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2AdminRemoveFeatureFlagInvestor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupFeatureFlagsQueryKey = (options) => createQueryKey('v2GetStartupFeatureFlags', options);
/**
 * Resolve feature flag values for a given startup
 */
export const v2GetStartupFeatureFlagsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupFeatureFlags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupFeatureFlagsQueryKey(options)
});
export const v2GetSignInProvidersQueryKey = (options) => createQueryKey('v2GetSignInProviders', options);
/**
 * Which sign-in providers are currently available, besides the email code
 */
export const v2GetSignInProvidersOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetSignInProviders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetSignInProvidersQueryKey(options)
});
export const v2GetOutreachPricingQueryKey = (options) => createQueryKey('v2GetOutreachPricing', options);
/**
 * Get outreach billing pricing (view + call costs, deposit options)
 */
export const v2GetOutreachPricingOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetOutreachPricing({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetOutreachPricingQueryKey(options)
});
export const v2GetStartupOutreachStatusQueryKey = (options) => createQueryKey('v2GetStartupOutreachStatus', options);
/**
 * Get outreach status for a startup
 */
export const v2GetStartupOutreachStatusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupOutreachStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupOutreachStatusQueryKey(options)
});
/**
 * Enable automated outreach for a startup
 */
export const v2EnableStartupOutreachMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2EnableStartupOutreach({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Disable automated outreach for a startup
 */
export const v2DisableStartupOutreachMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2DisableStartupOutreach({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupOutreachMessagesQueryKey = (options) => createQueryKey('v2GetStartupOutreachMessages', options);
/**
 * Get the founder outreach messages (msg1/msg2/msg3) and approval state
 */
export const v2GetStartupOutreachMessagesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupOutreachMessages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupOutreachMessagesQueryKey(options)
});
/**
 * Update one or more founder outreach messages (msg1/msg2/msg3)
 */
export const v2UpdateStartupOutreachMessagesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdateStartupOutreachMessages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Drop the founder edit for one message and use the generated version
 */
export const v2ResetStartupOutreachMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ResetStartupOutreachMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Mark the founder outreach messages as reviewed (launch-checklist gate)
 */
export const v2ReviewStartupOutreachMessagesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ReviewStartupOutreachMessages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Choose which outreach channels to run (Choose campaigns launch-checklist gate)
 */
export const v2SelectStartupOutreachChannelsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SelectStartupOutreachChannels({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Approve the founder messages and launch the outreach campaign
 */
export const v2LaunchStartupOutreachMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2LaunchStartupOutreach({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupOutreachContactDecisionsQueryKey = (options) => createQueryKey('v2GetStartupOutreachContactDecisions', options);
/**
 * List the founder pre-launch approve/decline decisions for the preview board
 */
export const v2GetStartupOutreachContactDecisionsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupOutreachContactDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupOutreachContactDecisionsQueryKey(options)
});
/**
 * Upsert one or more pre-launch contact approve/decline decisions
 */
export const v2SetStartupOutreachContactDecisionsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SetStartupOutreachContactDecisions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupOutreachQueueQueryKey = (options) => createQueryKey('v2GetStartupOutreachQueue', options);
/**
 * List contacts awaiting the founder approval, with investor profiles + messages
 */
export const v2GetStartupOutreachQueueOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupOutreachQueue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupOutreachQueueQueryKey(options)
});
/**
 * Approve a queued contact — they will be contacted on the next send
 */
export const v2ApproveStartupOutreachQueuedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ApproveStartupOutreachQueued({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Approve every contact still awaiting approval on the board
 */
export const v2ApproveAllStartupOutreachQueuedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ApproveAllStartupOutreachQueued({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Skip every contact still awaiting approval, keeping them restorable
 */
export const v2SkipAllStartupOutreachQueuedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SkipAllStartupOutreachQueued({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Decline a queued contact — they will not be contacted (moves to archive)
 */
export const v2DeclineStartupOutreachQueuedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2DeclineStartupOutreachQueued({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Archive a finished (no-response) contact — moves it to the Archive page
 */
export const v2ArchiveStartupOutreachContactMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ArchiveStartupOutreachContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Remove an in-progress lead from HeyReach and archive it — stops the sequence immediately
 */
export const v2RemoveStartupOutreachInProgressLeadMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RemoveStartupOutreachInProgressLead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupOutreachArchiveQueryKey = (options) => createQueryKey('v2GetStartupOutreachArchive', options);
/**
 * List archived outreach contacts (declined + finished), with profiles + messages
 */
export const v2GetStartupOutreachArchiveOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupOutreachArchive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupOutreachArchiveQueryKey(options)
});
/**
 * Restore an archived contact back onto the board
 */
export const v2RestoreStartupOutreachArchivedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RestoreStartupOutreachArchived({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupOutreachOverviewQueryKey = (options) => createQueryKey('v2GetStartupOutreachOverview', options);
/**
 * Get KPI, funnel, and reply-outcome breakdown for the dashboard
 */
export const v2GetStartupOutreachOverviewOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupOutreachOverview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupOutreachOverviewQueryKey(options)
});
/**
 * Mark specific replies as read once the founder has actually seen them
 */
export const v2MarkRepliesSeenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2MarkRepliesSeen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupOutreachOutcomesQueryKey = (options) => createQueryKey('v2GetStartupOutreachOutcomes', options);
/**
 * Get combined-campaign totals, daily series, and confirmed outcomes
 */
export const v2GetStartupOutreachOutcomesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupOutreachOutcomes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupOutreachOutcomesQueryKey(options)
});
/**
 * Remove the LinkedIn sender from HeyReach and reset outreach for re-setup
 */
export const v2RequestOutreachDisconnectMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RequestOutreachDisconnect({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupOutreachActivityQueryKey = (options) => createQueryKey('v2GetStartupOutreachActivity', options);
/**
 * Merged outreach activity timeline (campaign events + charges + topups)
 */
export const v2GetStartupOutreachActivityOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupOutreachActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupOutreachActivityQueryKey(options)
});
export const v2GetPortfolioOutreachStatusQueryKey = (options) => createQueryKey('v2GetPortfolioOutreachStatus', options);
/**
 * Get portfolio outreach status for a startup
 */
export const v2GetPortfolioOutreachStatusOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPortfolioOutreachStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPortfolioOutreachStatusQueryKey(options)
});
/**
 * Enable portfolio outreach for a startup
 */
export const v2EnablePortfolioOutreachMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2EnablePortfolioOutreach({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Pause the portfolio outreach campaign
 */
export const v2PausePortfolioOutreachMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2PausePortfolioOutreach({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Resume the portfolio outreach campaign
 */
export const v2ResumePortfolioOutreachMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ResumePortfolioOutreach({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetPortfolioOutreachMessagesQueryKey = (options) => createQueryKey('v2GetPortfolioOutreachMessages', options);
/**
 * Get portfolio outreach message templates
 */
export const v2GetPortfolioOutreachMessagesOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPortfolioOutreachMessages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPortfolioOutreachMessagesQueryKey(options)
});
/**
 * Update portfolio outreach message templates
 */
export const v2UpdatePortfolioOutreachMessagesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2UpdatePortfolioOutreachMessages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Drop the founder edit for one portfolio message and use the generated version
 */
export const v2ResetPortfolioOutreachMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ResetPortfolioOutreachMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Mark portfolio outreach messages as reviewed
 */
export const v2ReviewPortfolioOutreachMessagesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ReviewPortfolioOutreachMessages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetPortfolioContactPreviewsQueryKey = (options) => createQueryKey('v2GetPortfolioContactPreviews', options);
/**
 * Get portfolio contacts for pre-launch approval board
 */
export const v2GetPortfolioContactPreviewsOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPortfolioContactPreviews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPortfolioContactPreviewsQueryKey(options)
});
/**
 * Save approve/decline decisions for portfolio contacts
 */
export const v2SetPortfolioContactDecisionsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SetPortfolioContactDecisions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Approve the portfolio contact list and proceed to launch
 */
export const v2ApprovePortfolioContactsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ApprovePortfolioContacts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Launch the portfolio outreach campaign
 */
export const v2LaunchPortfolioCampaignMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2LaunchPortfolioCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetPortfolioQueueQueryKey = (options) => createQueryKey('v2GetPortfolioQueue', options);
/**
 * Get portfolio outreach kanban queue
 */
export const v2GetPortfolioQueueOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPortfolioQueue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPortfolioQueueQueryKey(options)
});
/**
 * Skip every founder still awaiting approval, keeping them restorable
 */
export const v2SkipAllPortfolioQueuedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SkipAllPortfolioQueued({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Archive a finished portfolio outreach message
 */
export const v2ArchivePortfolioMessageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2ArchivePortfolioMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetPortfolioArchiveQueryKey = (options) => createQueryKey('v2GetPortfolioArchive', options);
/**
 * List archived portfolio founders (skipped, declined, engaged, no response)
 */
export const v2GetPortfolioArchiveOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetPortfolioArchive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetPortfolioArchiveQueryKey(options)
});
/**
 * Restore an archived portfolio founder back onto the board
 */
export const v2RestorePortfolioArchivedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RestorePortfolioArchived({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Confirm or dismiss a warm intro candidate
 */
export const v2SubmitPortfolioWarmIntroDecisionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2SubmitPortfolioWarmIntroDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetStartupWalletQueryKey = (options) => createQueryKey('v2GetStartupWallet', options);
/**
 * Get wallet balance + lifetime totals
 */
export const v2GetStartupWalletOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetStartupWallet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetStartupWalletQueryKey(options)
});
/**
 * Start a Stripe Checkout flow for a wallet top-up
 */
export const v2CreateWalletTopUpCheckoutMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2CreateWalletTopUpCheckout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Open the Stripe Customer Portal for wallet billing
 */
export const v2OpenWalletBillingPortalMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2OpenWalletBillingPortal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Request a withdrawal of the wallet balance (emails ops)
 */
export const v2RequestWalletWithdrawalMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2RequestWalletWithdrawal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * HeyReach: lead profile viewed (warm-up)
 */
export const v2WebhookHeyreachViewedProfileMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2WebhookHeyreachViewedProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * HeyReach: lead post liked (warm-up)
 */
export const v2WebhookHeyreachLikedPostMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2WebhookHeyreachLikedPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * HeyReach: connection request sent
 */
export const v2WebhookHeyreachConnectionRequestSentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2WebhookHeyreachConnectionRequestSent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * HeyReach: connection request accepted
 */
export const v2WebhookHeyreachConnectionAcceptedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2WebhookHeyreachConnectionAccepted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * HeyReach: first message reply
 */
export const v2WebhookHeyreachMessageReplyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2WebhookHeyreachMessageReply({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * HeyReach: every message reply
 */
export const v2WebhookHeyreachEveryMessageReplyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2WebhookHeyreachEveryMessageReply({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * HeyReach: campaign completed per lead
 */
export const v2WebhookHeyreachCampaignCompletedMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2WebhookHeyreachCampaignCompleted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
export const v2GetFinFounderContextQueryKey = (options) => createQueryKey('v2GetFinFounderContext', options);
/**
 * Founder profile/evaluation context for the Intercom Fin chatbot
 */
export const v2GetFinFounderContextOptions = (options) => queryOptions({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await v2GetFinFounderContext({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: v2GetFinFounderContextQueryKey(options)
});
/**
 * Handle Stripe webhook events
 */
export const v2StripeWebhookMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2StripeWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
/**
 * Receive a message sent to a startup updates address (Resend inbound)
 */
export const v2WebhookResendInboundMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (fnOptions) => {
            const { data } = await v2WebhookResendInbound({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
